/**
 * Clés FR absentes de la fusion i18n-ar*.ts — couverture 100 %.
 * Valeurs EN par défaut. Généré par scripts/build-all-lang-gaps.mjs.
 */
export const arGapTranslations: Record<string, string> = {
  "webinar.room.speechTab": "Speech",
  "webinar.room.speechPanelHint": "Text captured from presenters’ microphones (browser speech recognition). The name shown is the person currently speaking.",
  "webinar.room.speechEmpty": "When a presenter speaks with the microphone on, their words appear here with their name. Punctuation follows the browser’s transcript.",
  "webinar.room.speechUnknownSpeaker": "Presenter",
  "webinar.room.speechPresenterActive": "Your voice is transcribed by the browser and sent to participants (Speech tab).",
  "webinar.room.speechUnsupportedBrowser": "Automatic presenter captions are not available in this browser (try Chrome or Edge).",
  "webinar.room.leave": "Leave room",
  "webinar.room.contentFocusExpand": "Content fills the stage",
  "webinar.room.contentFocusCollapse": "Show backdrop and presenters",
  "webinar.room.contentFocusAriaExpand": "Expand shared course, uploaded document or screen share full width without stage backdrop or presenter cameras",
  "webinar.room.liveDocumentLabel": "Upload (PDF or PowerPoint)",
  "webinar.room.liveDocumentUploadChoice": "Pick a file to display",
  "webinar.room.liveDocumentUploading": "Uploading…",
  "webinar.room.liveDocumentUploadError": "Could not upload the file. Check the format (PDF or PowerPoint) and size (max 40 MB).",
  "webinar.room.liveDocumentClose": "Remove document",
  "webinar.room.liveDocumentBehindScreen": "The document stays available — stop screen sharing to show it again.",
  "webinar.room.waitingSharedContentExtended": "Waiting for the presenter to share a catalog course, a file (PDF or PowerPoint), or their screen.",
  "webinar.room.liveDocumentOfficeHint": "If preview fails (plain HTTP locally or oversized file), use the link above.",
  "webinar.room.liveDocumentOpenOrDownload": "Open or download the file",
  "webinar.room.liveDocumentNoInlinePreview": "This file cannot be embedded automatically. Open it in a new tab.",
  "webinar.room.liveDocumentOpenTab": "Open",
  "webinar.room.pollTab": "Poll",
  "webinar.room.poll.regionTitle": "Webinar poll",
  "webinar.room.poll.presenterHint": "Add a question and 2–8 answers. Everyone sees the poll here; only hosts see live results.",
  "webinar.room.poll.questionLabel": "Question",
  "webinar.room.poll.questionPlaceholder": "E.g. Which topic should we cover next?",
  "webinar.room.poll.optionsLabel": "Answer choices",
  "webinar.room.poll.optionNumber": "Answer",
  "webinar.room.poll.choiceLabel": "Choice",
  "webinar.room.poll.addOption": "Add an answer",
  "webinar.room.poll.removeLastOption": "Remove last",
  "webinar.room.poll.launch": "Start poll",
  "webinar.room.poll.waitingParticipant": "No active poll yet. The host can start one.",
  "webinar.room.poll.voteHint": "One vote saved per person: you can change your answer by picking another option.",
  "webinar.room.poll.yourVote": "your pick",
  "webinar.room.poll.resultsHeading": "Results (hosts)",
  "webinar.room.poll.noVotesYet": "No votes yet.",
  "webinar.room.poll.totalVotes": "Total votes: {{n}}",
  "webinar.room.poll.closePoll": "Close poll",
  "webinar.room.contentFocusAriaCollapse": "Restore stage backdrop and presenter column",
  "webinar.room.exitDirectTitle": "Leave this webinar?",
  "webinar.room.exitDirectMessage": "You opened this room from a direct link (not from the dashboard). You can close this tab. If the browser blocks closing, you will be redirected to your home area.",
  "webinar.room.exitDirectConfirm": "Close tab",
  "webinar.room.publicGateEmail": "Email",
  "webinar.room.publicGatePasswordHintParticipant": "First visit: registration. Next visits: same email and password. Minimum 8 characters.",
  "nav.funnels": "Sales funnels",
  "nav.section.marketing": "Marketing & sales",
  "nav.section.institution": "Organization & management",
  "nav.marketingHub": "Overview",
  "nav.contacts": "Contacts",
  "nav.emailMarketing": "Email marketing",
  "nav.automations": "Automations",
  "nav.siteWeb": "Website",
  "nav.creatorPage": "Creator page",
  "nav.crm": "CRM pipeline",
  "nav.affiliate": "Affiliate",
  "nav.booking": "Booking",
  "nav.communities": "Communities",
  "nav.webinarsEvergreen": "Webinars",
  "nav.physicalProducts": "Physical products",
  "nav.smsMarketing": "SMS",
  "nav.section.activity": "Mon activité",
  "pages.learners.loading": "Loading learners…",
  "pages.learners.loadError": "Could not load learners",
  "pages.learners.retry": "Retry",
  "pages.learners.emptyFiltered": "No learners found",
  "pages.learners.emptyFilteredHint": "Try changing your search or filters",
  "pages.learners.emptyNone": "No enrolled learners yet",
  "pages.learners.emptyNoneHint": "Learners will appear here when they enroll in your published courses",
  "pages.learners.pagination": "Page {{page}} of {{totalPages}} · {{total}} learner(s)",
  "pages.learners.prev": "Previous",
  "pages.learners.next": "Next",
  "pages.learners.csvLastName": "Last name",
  "pages.learners.csvFirstName": "First name",
  "pages.learners.csvEmail": "Email",
  "pages.learners.csvFormations": "Courses",
  "pages.learners.csvAvgProgress": "Average progress",
  "pages.learners.csvTotalTime": "Total time",
  "pages.learners.csvLastActivity": "Last activity",
  "header.backToInstitutionAdmin": "Institution administration",
  "header.openTrainerWorkspace": "Trainer workspace & create content",
  "footer.a11yCenter": "Accessibility",
  "footer.supportChat": "Help & support",
  "form.email": "Email address",
  "form.password": "Password",
  "form.password_confirm": "Confirm password",
  "form.first_name": "First name",
  "form.last_name": "Last name",
  "form.name": "Name",
  "form.phone": "Phone",
  "form.address": "Address",
  "form.city": "City",
  "form.zip": "Zip code",
  "form.country": "Country",
  "form.title": "Title",
  "form.description": "Description",
  "form.category": "Category",
  "form.tags": "Tags",
  "form.status": "Status",
  "form.role": "Role",
  "form.date": "Date",
  "form.start_date": "Start date",
  "form.end_date": "End date",
  "form.duration": "Duration",
  "form.price": "Price",
  "form.avatar": "Profile picture",
  "form.required": "Required",
  "form.optional": "Optional",
  "form.select_placeholder": "Select...",
  "form.search_placeholder": "Search...",
  "form.no_results": "No results",
  "form.file_drop": "Drag and drop a file here or click to browse",
  "form.max_size": "Maximum size: {{size}}",
  "form.institution": "Institution",
  "form.department": "Department",
  "form.group": "Group",
  "form.level": "Level",
  "form.notes": "Notes",
  "form.url": "URL",
  "form.content": "Content",
  "form.thumbnail": "Thumbnail",
  "error.required": "This field is required",
  "error.email_invalid": "Invalid email address",
  "error.password_min": "Password must be at least {{min}} characters",
  "error.password_match": "Passwords do not match",
  "error.min_length": "Minimum {{min}} characters",
  "error.max_length": "Maximum {{max}} characters",
  "error.min_value": "Minimum value is {{min}}",
  "error.max_value": "Maximum value is {{max}}",
  "error.invalid_url": "Invalid URL",
  "error.file_too_large": "File is too large",
  "error.file_type": "Unsupported file type",
  "error.generic": "An error occurred",
  "error.network": "Network connection error",
  "error.unauthorized": "You must be logged in",
  "error.forbidden": "Access denied",
  "error.not_found": "Resource not found",
  "error.server": "Internal server error",
  "error.conflict": "This resource already exists",
  "error.rate_limit": "Too many requests, please wait",
  "auth.login": "Log in",
  "auth.logout": "Log out",
  "auth.register": "Sign up",
  "auth.forgot_password": "Forgot password?",
  "auth.reset_password": "Reset password",
  "auth.otp_title": "Login with code",
  "auth.otp_sent": "A verification code has been sent to {{email}}",
  "auth.otp_placeholder": "Enter the 6-digit code",
  "auth.google_login": "Continue with Google",
  "auth.remember_me": "Remember me",
  "auth.no_account": "No account yet?",
  "auth.has_account": "Already have an account?",
  "auth.welcome_back": "Welcome back, {{name}}!",
  "auth.login_success": "Login successful",
  "auth.register_success": "Account created successfully",
  "auth.logout_success": "Logout successful",
  "dashboard.recent_projects": "Recent projects",
  "dashboard.recent_activity": "Recent activity",
  "dashboard.quick_actions": "Quick actions",
  "dashboard.stats": "Statistics",
  "dashboard.total_projects": "Total projects",
  "dashboard.total_learners": "Total learners",
  "dashboard.total_eduflows": "Total courses",
  "dashboard.completion_rate": "Completion rate",
  "dashboard.active_users": "Active users",
  "dashboard.new_registrations": "New registrations",
  "dashboard.revenue": "Revenue",
  "dashboard.home.greeting": "Hello {{name}}",
  "dashboard.home.greetingSubtitle": "Manage your courses, learning paths and podcasts from one place.",
  "dashboard.home.primaryCta": "Create a course",
  "dashboard.home.continueEditing": "Resume last edit",
  "dashboard.home.publishRate": "Publication rate",
  "dashboard.home.totalFormations": "Courses created",
  "dashboard.home.uniqueLearners": "Learners reached",
  "dashboard.home.calendarKicker": "Activity this month",
  "dashboard.home.recentWork": "Recent updates",
  "dashboard.home.viewAll": "View all",
  "dashboard.home.quickAccess": "Quick access",
  "dashboard.home.loading": "Loading dashboard…",
  "dashboard.home.defaultName": "trainer",
  "dashboard.lo.heroTitle": "Welcome to your learning creation space.",
  "dashboard.lo.heroSubtitle": "Create courses, podcasts, and AI-assisted learning paths.",
  "dashboard.lo.newFormation": "New course",
  "dashboard.lo.generateAi": "Generate with AI",
  "dashboard.lo.aiGenerations": "AI generations",
  "dashboard.lo.recentActivity": "Recent activity",
  "dashboard.lo.activityFormationPublished": "Course published",
  "dashboard.lo.activityFormationEdited": "Course updated",
  "dashboard.lo.activityPodcastPublished": "Podcast published",
  "dashboard.lo.activityPodcastEdited": "Podcast updated",
  "dashboard.certificatesIssued": "Certificates issued",
  "dashboard.newProject": "New project",
  "dashboard.uploadMedia": "Upload media",
  "dashboard.viewDocs": "Documentation",
  "dashboard.recentProjects": "Recent projects",
  "dashboard.noRecentProjects": "No recent projects",
  "dashboard.activity": "Activity",
  "dashboard.searchProjects": "Search projects...",
  "dashboard.noProjects": "No projects yet",
  "dashboard.createFirst": "Create your first project to get started",
  "dashboard.createProject": "Create project",
  "dashboard.projectTitle": "Project title",
  "dashboard.calendar.mon": "Mon",
  "dashboard.calendar.wed": "Wed",
  "dashboard.calendar.fri": "Fri",
  "dashboard.calendar.less": "Less",
  "dashboard.calendar.more": "More",
  "dashboard.calendar.tooltip": "{{count}} activit(ies) on {{date}}",
  "dashboard.mock.updated2h": "2h ago",
  "dashboard.mock.updated5h": "5h ago",
  "dashboard.mock.updatedYesterday": "Yesterday",
  "dashboard.period.week": "Week",
  "dashboard.period.month": "Month",
  "dashboard.period.quarter": "Quarter",
  "dashboard.vsLastPeriod": "vs previous period ({{period}})",
  "dashboard.completionPercent": "Completion %",
  "dashboard.activeLearners": "Active learners",
  "dashboard.sessions": "Sessions",
  "dashboard.activityType.completion": "Completed",
  "dashboard.activityType.enrollment": "Enrollment",
  "dashboard.activityType.milestone": "Milestone",
  "dashboard.activityType.feedback": "Feedback",
  "dashboard.activityType.start": "Start",
  "dashboard.totalLearners": "Total learners",
  "dashboard.activeEduFlows": "Active training paths",
  "dashboard.publishedTraining": "Published courses",
  "dashboard.activeUsersPeriod": "Active users (period)",
  "dashboard.completionRate": "Completion rate",
  "dashboard.npsScore": "NPS score",
  "dashboard.topEduFlows": "Top training paths",
  "dashboard.topEduFlowsHint": "Completion rate among the most enrolled courses (sorted by learner count).",
  "dashboard.engagement": "Learner engagement",
  "dashboard.xp_earned": "XP earned",
  "dashboard.streak": "Current streak",
  "dashboard.level": "Level {{level}}",
  "dashboard.badges_earned": "Badges earned",
  "dashboard.next_level": "Next level",
  "dashboard.no_projects": "No projects yet",
  "dashboard.create_first": "Create your first project",
  "dashboard.pending_reviews": "Pending reviews",
  "dashboard.upcoming_deadlines": "Upcoming deadlines",
  "podcast.episodes.filterAllPodcasts": "All podcasts",
  "podcast.episodes.unassignedPodcast": "No podcast",
  "podcast.episodes.generateVoiceOff": "Generate voice-over",
  "podcast.episodes.generateVoiceConfirmTitle": "Generate voice-over?",
  "podcast.episodes.generateVoiceConfirmMessage": "Episode « {{title}} » will be synthesized ({{count}} segment(s)). This may take several minutes.",
  "podcast.episodes.generateVoiceConfirmButton": "Generate",
  "podcast.episodes.generateNoBlocks": "No script text or microphone recording on this episode — open the editor to add content.",
  "podcast.episodes.generateSuccess": "Voice-over generated for « {{title}} » ({{count}} segment(s)).",
  "podcast.episodes.generateError": "Voice-over generation failed.",
  "podcast.episodes.publish": "Publish episode",
  "podcast.episodes.publishConfirmTitle": "Publish this episode?",
  "podcast.episodes.publishConfirmMessage": "« {{title}} » will be visible to learners assigned to the podcast (published status).",
  "podcast.episodes.publishConfirmButton": "Publish",
  "podcast.episodes.publishSuccess": "« {{title}} » is published.",
  "podcast.episodes.publishError": "Publication failed.",
  "podcast.episodes.audioReady": "Audio ready",
  "eduflow.title": "EduFlow editor",
  "eduflow.new_flow": "New course",
  "eduflow.participant.flowTitle": "Learning path",
  "eduflow.participant.stepWelcome": "Welcome",
  "eduflow.participant.stepModule1": "Module 1",
  "eduflow.participant.stepEvaluation": "Assessment",
  "eduflow.participant.stepContentPlaceholder": "Interactive step content displayed for the learner.",
  "eduflow.designer.flowSettings.focusGuard.title": "Focus loss check",
  "eduflow.designer.flowSettings.focusGuard.hint": "If the learner leaves the tab or page, the training is paused (dimmed screen, click to resume).",
  "eduflow.designer.flowSettings.focusGuard.limitLabel": "Allowed exits",
  "eduflow.designer.flowSettings.focusGuard.unlimited": "Unlimited",
  "eduflow.designer.flowSettings.focusGuard.limited": "Limited",
  "eduflow.designer.flowSettings.focusGuard.lossesUnit": "allowed focus loss(es)",
  "eduflow.designer.flowSettings.focusGuard.blockWarning": "Beyond this number, the learner can no longer continue the training.",
  "eduflow.designer.flowSettings.coverUploadError": "Could not upload the cover image.",
  "eduflow.designer.flowSettings.certificate.uploadError": "Invalid server response.",
  "eduflow.designer.flowSettings.certificate.uploadFailed": "Could not upload the Word template.",
  "eduflow.designer.blockLabel.audio": "Audio",
  "eduflow.ragChatbot.uploadSavedNotIndexed": "Document saved. It will not be used for RAG until the vector store is configured on the server.",
  "eduflow.ragChatbot.ragIndexFailed": "Document saved but not indexed. Check pgvector (DATABASE_VECTOR_URL) and Mistral, then re-upload if needed.",
  "eduflow.designer.aiPanel.askBeforeAct": "Ask before acting",
  "eduflow.designer.aiPanel.askBeforeActHint": "When on, changes are shown in chat before applying to the graph.",
  "eduflow.designer.aiPanel.captureScreenHint": "Capture canvas and Properties panel",
  "eduflow.designer.aiPanel.captureReady": "Screenshot ready — send your instruction.",
  "eduflow.designer.aiPanel.captureFailed": "Could not capture the screen.",
  "eduflow.designer.aiPanel.captureAttached": "Screenshot will be sent with your next message",
  "eduflow.designer.aiPanel.removeCapture": "Remove",
  "eduflow.designer.aiPanel.captureInMessage": "Screen capture",
  "eduflow.designer.aiPanel.statusCapturing": "Capturing the interface…",
  "eduflow.designer.aiPanel.statusAnalyzing": "Analyzing screen and focused block…",
  "eduflow.designer.aiPanel.statusWorking": "Working on your request…",
  "eduflow.designer.aiPanel.statusApplying": "Applying to the canvas…",
  "eduflow.designer.aiPanel.captureDisclaimer": "AI can make mistakes — review generated content. Paste an image (Ctrl+V) or use capture.",
  "eduflow.designer.resizeAiPanel": "Resize AI assistant panel",
  "eduflow.designer.aiPanel.subtitle": "Copilot: content, graph, and objectives.",
  "eduflow.designer.aiPanel.focusContextLabel": "Target:",
  "eduflow.designer.aiPanel.focusPrimary": "\"{{label}}\" ({{type}}) — Properties",
  "eduflow.designer.aiPanel.focusMulti": "{{count}} blocks selected — say which to edit, or focus one block.",
  "eduflow.designer.aiPanel.focusNone": "No focused block — open Properties on a node or name a block in your message.",
  "eduflow.designer.aiPanel.followUpsLabel": "Suggested next steps",
  "eduflow.designer.aiPanel.ideasToggle": "Ready-made ideas",
  "eduflow.designer.aiPanel.advancedToggle": "Options (stream, sources, shortcuts…)",
  "eduflow.designer.aiPanel.removeDocument": "Remove",
  "eduflow.designer.aiPanel.importDocumentTitle": "Import PDF, Word, or PowerPoint",
  "eduflow.designer.aiPanel.webSourcesLabel": "Web pages (max 3, optional)",
  "eduflow.designer.aiPanel.webSourcesPlaceholder": "https://example.org/doc\nhttps://…",
  "eduflow.designer.aiPanel.idea.auditPath": "Audit the graph: broken paths, isolated nodes and flow order — apply fixes",
  "eduflow.designer.aiPanel.idea.microLearning": "Design a concise micro‑learning variant from the current flow while preserving intent",
  "eduflow.designer.aiPanel.idea.formativeGap": "Insert short formative bridging activities wherever the pathway is cognitively heavy",
  "eduflow.designer.aiPanel.idea.titleCoherence": "Align block titles with the project title and the overall training tone",
  "eduflow.designer.aiPanel.idea.remediation": "Add a remediation path after the main MCQ quiz (failure / low-score branch)",
  "eduflow.designer.aiPanel.idea.mobileWording": "Shorten and clarify HTML text in blocks that are too long on mobile",
  "eduflow.designer.aiPanel.idea.quizWording": "Unify wording style across all quiz instructions (“Select…”, tone, formal register)",
  "eduflow.designer.aiPanel.idea.summaryBeforeEnd": "Add or rewrite a recap block immediately before the End node",
  "eduflow.designer.aiPanel.streamMode": "Streaming",
  "eduflow.designer.aiPanel.streamModeHint": "Response streams as it generates; the final payload is normalized like non-streaming mode.",
  "eduflow.designer.aiPanel.streamError": "Stream interrupted or refused.",
  "eduflow.designer.aiPanel.streamIncomplete": "Incomplete response from server. Retry or disable streaming.",
  "eduflow.designer.aiPanel.skillPath": "Path audit (server)",
  "eduflow.designer.aiPanel.skillPathHint": "Structural graph analysis added to the prompt.",
  "eduflow.designer.aiPanel.skillQuiz": "Strict MCQ schema (server)",
  "eduflow.designer.aiPanel.skillQuizHint": "Official Lyrra quiz_mcq template in the prompt.",
  "eduflow.designer.aiPanel.thinking": "The assistant is thinking…",
  "eduflow.designer.aiPanel.serverSkills": "Server boosts",
  "eduflow.designer.aiPanel.newConversation": "New conversation",
  "eduflow.designer.aiPanel.clearConversation": "Clear conversation",
  "eduflow.designer.aiPanel.conversationHistory": "History",
  "eduflow.designer.aiPanel.deleteConversation": "Delete",
  "eduflow.designer.aiPanel.maxConversations": "You’ve reached the limit of {{max}} saved conversations. Delete one to start a new one.",
  "eduflow.designer.aiPanel.unnamedConversation": "Conversation",
  "eduflow.designer.aiQuick.rewriteFocus": "Rewrite Properties block",
  "eduflow.designer.aiQuick.translateFocus": "Translate Properties block (FR)",
  "eduflow.designer.flowVariablesTitle": "Global variables",
  "eduflow.designer.flowVariables.subtitle": "Set key / value pairs. Use @ followed by the key name in block titles and descriptions (e.g. @course_name). Values are substituted for learners.",
  "eduflow.designer.flowVariables.empty": "No variables yet. Add some to personalize course wording.",
  "eduflow.designer.flowVariables.keyLabel": "Key",
  "eduflow.designer.flowVariables.keyPlaceholder": "e.g. course_name",
  "eduflow.designer.flowVariables.keyHelp": "Letters, numbers, hyphen and underscore only. @key matching is case-sensitive.",
  "eduflow.designer.flowVariables.valueLabel": "Default value",
  "eduflow.designer.flowVariables.valuePlaceholder": "Text shown instead of @key",
  "eduflow.designer.flowVariables.add": "Add variable",
  "eduflow.designer.flowVariables.delete": "Remove",
  "eduflow.designer.flowVariables.invalidKey": "Each key must be set and use only allowed characters.",
  "eduflow.designer.flowVariables.duplicateKey": "Duplicate keys (case-insensitive) are not allowed.",
  "eduflow.designer.flowVariables.savedToast": "Variables saved",
  "eduflow.designer.flowVariables.errorToast": "Could not save variables.",
  "eduflow.designer.flowVariables.saveNow": "Save now",
  "eduflow.designer.blockFlowVariablesHint": "Global variables: use @your_key in the title or description (configure them with the { } icon in the toolbar).",
  "eduflow.designer.blockFlowVariablesPreviewTitle": "Preview (title)",
  "eduflow.designer.blockFlowVariablesPreviewDescription": "Preview (description)",
  "eduflow.designer.flowVariables.mentionNoMatch": "No matching variable.",
  "eduflow.designer.formFieldsSlash.mentionNoMatch": "No matching field.",
  "eduflow.designer.textVoiceoverHint": "The voiceover reads both the block description and main content.",
  "eduflow.designer.blockLockedReadOnly": "This block is locked: properties are shown as read-only.",
  "eduflow.translation.prefsSaveError": "Could not save translation preferences (per-language Text / Audio toggles).",
  "project.title": "Projects",
  "project.new": "New project",
  "project.name": "Project name",
  "project.description": "Project description",
  "project.status.in_review": "In review",
  "project.visibility.public": "Public",
  "project.visibility.private": "Private",
  "project.visibility.institution": "Organization",
  "project.no_projects": "No projects found",
  "project.delete_confirm": "Are you sure you want to delete this project?",
  "store.title": "Store",
  "store.search": "Rechercher...",
  "store.categories": "Categories",
  "store.price": "Price",
  "store.free": "Free",
  "store.buy": "Buy",
  "store.add_to_cart": "Add to cart",
  "store.cart": "Cart",
  "store.checkout": "Checkout",
  "store.reviews": "Reviews",
  "store.rating": "Rating",
  "store.my_purchases": "My purchases",
  "store.no_items": "No items found",
  "audio.title": "Audio Studio",
  "audio.audiobooks": "Audiobooks",
  "audio.new_audiobook": "New audiobook",
  "audio.record": "Record",
  "audio.stop": "Stop",
  "audio.play": "Play",
  "audio.pause": "Pause",
  "audio.volume": "Volume",
  "audio.tracks": "Tracks",
  "audio.add_track": "Add track",
  "audio.remove_track": "Remove track",
  "audio.effects": "Effects",
  "audio.export": "Export",
  "audio.export_format": "Export format",
  "audio.duration": "Duration",
  "audio.narrator": "Narrator",
  "audio.chapter": "Chapter",
  "notification.title": "Notifications",
  "notification.mark_all_read": "Mark all as read",
  "notification.no_notifications": "No notifications",
  "notification.new": "New notification",
  "notification.type.info": "Information",
  "notification.type.success": "Success",
  "notification.type.warning": "Warning",
  "notification.type.error": "Error",
  "settings.title": "Settings",
  "settings.general": "General",
  "settings.account": "Account",
  "settings.security": "Security",
  "settings.appearance": "Appearance",
  "settings.notifications": "Notifications",
  "settings.language": "Language",
  "settings.theme": "Theme",
  "settings.theme.light": "Light",
  "settings.theme.dark": "Dark",
  "settings.theme.system": "System",
  "settings.accessibility": "Accessibility",
  "settings.font_size": "Font size",
  "settings.high_contrast": "High contrast",
  "settings.reduced_motion": "Reduced motion",
  "settings.dyslexia_mode": "Dyslexia mode",
  "analytics.title": "Analytics",
  "analytics.overview": "Overview",
  "analytics.learner_progress": "Learner progress",
  "analytics.engagement": "Engagement",
  "analytics.completion": "Completion",
  "analytics.time_spent": "Time spent",
  "analytics.average_score": "Average score",
  "analytics.export_report": "Export report",
  "gamification.xp": "XP",
  "gamification.level": "Niv.",
  "gamification.streak": "Streak",
  "gamification.badges": "Badges",
  "gamification.leaderboard": "Classement",
  "gamification.achievements": "Achievements",
  "gamification.daily_goal": "Daily goal",
  "gamification.congratulations": "Congratulations!",
  "gamification.new_badge": "New badge unlocked!",
  "gamification.level_up": "Level up!",
  "qualiopi.title": "Qualiopi compliance",
  "qualiopi.dashboard": "Qualiopi dashboard",
  "qualiopi.criteria": "Criterion {{number}}",
  "qualiopi.indicator": "Indicator {{number}}",
  "qualiopi.compliant": "Compliant",
  "qualiopi.non_compliant": "Non-compliant",
  "qualiopi.partial": "Partially compliant",
  "qualiopi.not_applicable": "Not applicable",
  "qualiopi.evidence": "Documents justificatifs",
  "qualiopi.upload_evidence": "Upload evidence",
  "qualiopi.audit_date": "Audit date",
  "qualiopi.next_audit": "Next audit",
  "qualiopi.compliance_score": "Compliance score",
  "qualiopi.action_plan": "Action plan",
  "training.plan": "Training plan",
  "training.request": "Training request",
  "training.requests": "Training requests",
  "training.catalog": "Training catalog",
  "training.budget": "Training budget",
  "training.campaign": "Interview campaign",
  "training.competency": "Skills framework",
  "training.gap_analysis": "Gap analysis",
  "training.roi": "Return on investment",
  "common.drag_drop": "Drag and drop",
  "common.online": "Online",
  "common.offline": "Offline",
  "common.version": "Version",
  "player.image.annotationNoDescription": "No description for this annotation.",
  "player.image.noneAvailable": "No image available",
  "player.visualAi.emptyTitle": "No AI visual configured",
  "player.visualAi.emptyHint": "Return to the designer to generate or configure this visual.",
  "player.visualAi.defaultTitle": "AI visual",
  "player.visualAi.subtitle": "Explore the diagram: zoom, scroll, or use full screen mode.",
  "player.visualAi.openFullscreen": "Open full screen",
  "player.visualAi.closeFullscreen": "Close full screen",
  "player.visualAi.badge": "AI visual",
  "player.visualAi.viewportLabel": "Interactive diagram — zoom and pan",
  "player.visualAi.toolbarLabel": "Diagram controls",
  "player.visualAi.zoomOut": "Zoom out",
  "player.visualAi.zoomIn": "Zoom in",
  "player.visualAi.resetZoom": "Reset zoom to 100%",
  "player.visualAi.reset": "100%",
  "player.visualAi.fitView": "Fit diagram to window",
  "player.visualAi.fit": "Fit",
  "player.visualAi.zoomLevel": "Zoom {{percent}}%",
  "player.visualAi.viewportHint": "Ctrl (or Cmd) + scroll wheel to zoom. Arrow keys to pan when the viewport is focused. Tab to reach the controls.",
  "player.unblockPublicLoginRequired": "In public mode without registration, unlock requests are not available. Complete the training registration form or sign in to LyrraOne.",
  "notifications.unblock.title": "Unlock request",
  "notifications.unblock.message": "{{name}} — {{flow}} ({{count}} exit(s))",
  "notifications.unblock.unknownLearner": "A learner",
  "notifications.unblock.unknownFlow": "Training",
  "notifications.unblock.approve": "Unlock",
  "notifications.unblock.reject": "Decline",
  "notifications.unblock.approvedToast": "Training unlocked for this learner.",
  "notifications.unblock.rejectedToast": "Unlock request declined.",
  "notifications.unblock.resolveError": "Could not process the request. Please try again.",
  "player.parallelBranchActionReplay": "Retake this path",
  "player.parallelBranchesGridLabel": "Parallel branch grid",
  "player.parallelBranchesScrollHint": "Scroll right (or use the arrows) to see more paths.",
  "player.parallelBranchesPageNav": "Path pages",
  "player.parallelBranchesPageIndicator": "Page {{current}} / {{total}}",
  "player.parallelBranchesPrevPage": "Previous paths",
  "player.parallelBranchesNextPage": "Next paths",
  "api.error.network": "Unable to reach the server. Check your connection.",
  "api.error.unexpected": "An unexpected error occurred.",
  "api.error.badRequest": "Invalid request.",
  "api.error.forbidden": "Access denied.",
  "api.error.notFound": "Resource not found.",
  "api.error.conflict": "Conflict — this resource already exists.",
  "api.error.unprocessable": "The submitted data is not valid.",
  "api.error.tooManyRequests": "Too many requests. Please try again shortly.",
  "api.error.server": "Internal server error.",
  "api.error.badGateway": "Service temporarily unavailable.",
  "api.error.maintenance": "Service under maintenance.",
  "api.error.generic": "Error {{status}}",
  "accessibility.preset.cumulHint": "Combine several profiles if needed",
  "accessibility.preset.clickToAdd": "Click to add",
  "accessibility.preset.clickToRemove": "Click to remove",
  "accessibility.readingMask": "Reading mask",
  "accessibility.readingMaskDesc": "An opaque band follows the cursor to isolate the current line — especially helpful for dyslexia and ADHD. Tip: Option ⌥ + =/+ or Option ⌥ + ↑/↓ (macOS); Alt + + / Alt − (Windows/Linux) to adjust the height.",
  "accessibility.speakOnSelection": "Speak selected text",
  "accessibility.speakOnSelectionDesc": "Select any text on the page: a button appears to read it aloud on demand (different from automatic audio reading).",
  "accessibility.speakSelection.listen": "Listen to selection",
  "accessibility.speakSelection.stop": "Stop reading",
  "accessibility.speakSelection.loading": "Generating…",
  "accessibility.speakSelection.retry": "Try again",
  "accessibility.speakSelection.error": "Read-aloud unavailable, please try again shortly.",
  "accessibility.speakSelection.region": "Read selection aloud",
  "a11y.voiceGuide.title": "Accessibility voice assistant",
  "a11y.help.shortcuts": "Keyboard shortcuts",
  "a11y.help.kbdEsc": "Close the panel / stop speech synthesis",
  "a11y.help.kbdMask": "Adjust reading mask height (mask enabled)",
  "a11y.help.kbdMaskMac": "Use = or + key (above numbers), or ↑ ↓ arrows with Option ⌥",
  "a11y.help.kbdMaskOther": "Windows / Linux: Alt + + / Alt + −",
  "a11y.help.kbdTab": "Move between interactive elements",
  "a11y.help.tips": "Tips",
  "a11y.voiceGuide.subtitle": "Describe your needs and I'll turn on the right options for you.",
  "a11y.voiceGuide.cta.title": "Describe your needs",
  "a11y.voiceGuide.cta.hint": "Speak: AI automatically enables the right options for you.",
  "a11y.voiceGuide.cta.openLabel": "Open the voice assistant to describe your accessibility needs",
  "a11y.voiceGuide.cta.start": "Start the voice assistant",
  "a11y.voiceGuide.cta.stop": "Stop listening",
  "a11y.voiceGuide.status": "Status",
  "a11y.voiceGuide.statusActive": "In progress",
  "a11y.voiceGuide.youSaid": "You said",
  "a11y.voiceGuide.reformulation": "Here is what I understood",
  "a11y.voiceGuide.applied": "Settings applied",
  "a11y.voiceGuide.resetButton": "Reset to normal",
  "a11y.voiceGuide.resetExplanation": "All accessibility settings have been reset to default.",
  "a11y.voiceGuide.problem": "Problem",
  "a11y.voiceGuide.micReady": "Mic ready",
  "a11y.voiceGuide.micUnsupported": "Speech recognition not supported",
  "a11y.voiceGuide.stage.idle": "Ready to listen",
  "a11y.voiceGuide.stage.intro": "Setting things up…",
  "a11y.voiceGuide.stage.listening": "I'm listening — speak freely.",
  "a11y.voiceGuide.stage.thinking": "Analyzing your needs…",
  "a11y.voiceGuide.stage.confirmPlaying": "Summarising…",
  "a11y.voiceGuide.stage.confirmListening": "Say 'yes' to confirm or 'no' to start over.",
  "a11y.voiceGuide.stage.applying": "Applying your settings…",
  "a11y.voiceGuide.stage.done": "Done!",
  "a11y.voiceGuide.stage.error": "Something went wrong.",
  "a11y.voiceGuide.error.mic": "Microphone access failed.",
  "a11y.voiceGuide.error.micDenied": "Microphone permission was denied. Please enable it in your browser settings.",
  "a11y.voiceGuide.error.stt": "Speech recognition is not available in this browser.",
  "a11y.voiceGuide.error.ai": "AI analysis unavailable.",
  "a11y.voiceGuide.error.serverUnavailable": "The Lyrra server is not responding correctly (often: backend not deployed or build error). Check deployment, then try again.",
  "a11y.voiceGuide.error.generic": "Something went wrong. Please try again or adjust settings manually.",
  "learner.header.workspace": "مساحة المتعلّم",
  "learner.tabs.home": "Home",
  "learner.tabs.parcours": "My Paths",
  "learner.tabs.formations": "My Courses",
  "learner.tabs.webinars": "Webinars",
  "learner.tabs.podcasts": "Podcasts",
  "learner.tabs.documents": "Documents",
  "learner.tabs.progress": "My Progress",
  "learner.tabs.profile": "Profile",
  "learner.sidebar.tagline": "Learner",
  "learner.sidebar.webinars": "Webinars",
  "learner.webinars.title": "My webinars",
  "learner.webinars.loading": "Loading your webinars…",
  "learner.webinars.empty": "No webinars yet. Email invitations and sessions where you present will appear here.",
  "learner.webinars.sectionInvited": "Invitations received",
  "learner.webinars.sectionPresenting": "Sessions I present",
  "learner.webinars.emptyInvited": "No invitations yet.",
  "learner.webinars.emptyPresenting": "You are not a presenter on any webinar.",
  "learner.webinars.rolePresenter": "Presenter",
  "learner.webinars.joinAsPresenter": "Open room (presenter)",
  "learner.webinars.join": "Join room",
  "learner.webinars.invitedOn": "Invited on",
  "learner.webinars.scheduledFor": "Scheduled for",
  "learner.webinars.duration": "Duration: {{duration}}",
  "learner.webinars.loadError": "Could not load webinars.",
  "learner.webinars.status.draft": "Draft",
  "learner.webinars.status.scheduled": "Scheduled",
  "learner.webinars.status.live": "Live",
  "learner.webinars.status.ended": "Ended",
  "learner.sidebar.myProfile": "My profile",
  "learner.sidebar.logout": "Log out",
  "learner.sidebar.collapse": "Collapse menu",
  "learner.sidebar.expandAria": "Expand sidebar",
  "learner.sidebar.collapseAria": "Collapse sidebar",
  "learner.sidebar.backToTrainer": "Trainer dashboard",
  "learner.sidebar.backToTrainerAria": "Go back to the trainer dashboard",
  "learner.home.defaultName": "learner",
  "learner.home.greeting": "Hello {{name}},",
  "learner.home.greetingSubtitle": "Pick up your learning where you left off.",
  "learner.home.resumeMyFormation": "Resume my course",
  "learner.home.globalProgress": "Overall progress",
  "learner.home.learningTime": "Learning time",
  "learner.home.badges": "Badges earned",
  "learner.home.calendarKicker": "My progress",
  "learner.home.quickAccess": "Quick access",
  "learner.learningPath": "Learning path",
  "learner.home.resumeTraining": "Resume your courses",
  "learner.home.viewAll": "View all →",
  "learner.home.trainingDomains": "Training domains",
  "learner.home.courses": "courses",
  "learner.home.episodes": "episodes",
  "learner.home.recommendedPodcasts": "Recommended podcasts",
  "learner.home.explore": "Explore →",
  "learner.formations.title": "My Courses",
  "learner.formations.searchPlaceholder": "Search a course…",
  "learner.formations.all": "All",
  "learner.formations.formation": "Course",
  "learner.formations.inProgress": "In progress",
  "learner.formations.completed": "Completed",
  "learner.formations.notStarted": "Not started",
  "learner.formations.loading": "Loading your courses...",
  "learner.formations.empty": "No course found.",
  "learner.formations.progress": "Progress",
  "learner.formations.instructor": "Instructor",
  "learner.formations.opening": "Opening...",
  "learner.formations.review": "Review",
  "learner.formations.start": "Start",
  "learner.formations.continue": "Continue",
  "learner.podcasts.title": "Explore Podcasts",
  "learner.podcasts.searchPlaceholder": "Search a podcast…",
  "learner.podcasts.all": "All",
  "learner.podcasts.assigned": "Assigned podcast",
  "learner.podcasts.defaultCategory": "Podcast",
  "learner.podcasts.loading": "Loading your podcasts...",
  "learner.podcasts.empty": "No assigned podcast.",
  "learner.podcasts.episodes": "episodes",
  "learner.podcasts.opening": "Opening...",
  "learner.podcasts.listen": "Listen",
  "learner.documents.title": "Shared Documents",
  "learner.documents.loading": "Loading your documents...",
  "learner.documents.view": "View document",
  "learner.documents.empty": "No shared document.",
  "learner.documents.personalTitle": "My personal documents",
  "learner.documents.personalHint": "Your personal documents are only visible to you. Click on a document to preview it and ask questions to the AI assistant.",
  "learner.documents.personalEmpty": "No personal document yet. Upload a PDF to get started.",
  "learner.documents.upload": "Upload a document",
  "learner.documents.delete": "Delete",
  "learner.documents.deleteConfirmTitle": "Delete this document?",
  "learner.documents.deleteConfirmDesc": "This action is permanent. The document and its AI analysis will be deleted.",
  "learner.documents.cancel": "Cancel",
  "learner.documents.confirmDelete": "Delete",
  "learner.documents.chatReady": "Chat ready",
  "learner.documents.processing": "Processing…",
  "learner.documents.backToList": "Back to documents",
  "learner.documents.chatTitle": "Ask about this document",
  "learner.documents.chatPlaceholder": "Ask a question about this document…",
  "learner.documents.chatPlaceholderHint": "Ask any question about this document. The assistant will only answer based on its content.",
  "learner.documents.chatError": "An error occurred.",
  "learner.documents.preview": "Preview",
  "learner.documents.indexing": "Analyzing your document…",
  "learner.progress.title": "My Progress",
  "learner.progress.completedFormations": "Completed courses",
  "learner.progress.trainingHours": "Training hours",
  "learner.progress.listenedPodcasts": "Podcasts listened",
  "learner.progress.earnedBadges": "Badges earned",
  "learner.progress.weeklyActivity": "Weekly activity",
  "learner.progress.badges": "Badges",
  "learner.progress.recentActivity": "Recent activity",
  "learner.progress.rarity.common": "Common",
  "learner.progress.rarity.rare": "Rare",
  "learner.progress.rarity.epic": "Epic",
  "learner.progress.rarity.legendary": "Legendary",
  "learner.progress.days.mon": "Mon",
  "learner.progress.days.tue": "Tue",
  "learner.progress.days.wed": "Wed",
  "learner.progress.days.thu": "Thu",
  "learner.progress.days.fri": "Fri",
  "learner.progress.days.sat": "Sat",
  "learner.progress.days.sun": "Sun",
  "learner.profile.title": "My Profile",
  "learner.profile.defaultName": "Learner",
  "learner.profile.defaultEmail": "learner@example.com",
  "learner.profile.memberSince": "Member since January 2024",
  "learner.profile.editProfile": "Edit profile",
  "learner.profile.formations": "Courses",
  "learner.profile.hours": "Hours",
  "learner.profile.podcasts": "Podcasts",
  "learner.profile.badges": "Badges",
  "learner.profile.preferences": "Preferences",
  "learner.profile.theme": "Theme",
  "learner.profile.themeLight": "Light",
  "learner.profile.themeDark": "Dark",
  "learner.profile.themeSystem": "System",
  "learner.profile.language": "Language",
  "learner.profile.notifications": "Notifications",
  "learner.profile.fontSize": "Text size",
  "learner.profile.fontNormal": "Normal",
  "learner.profile.fontLarge": "Large",
  "learner.profile.highContrast": "High contrast",
  "learner.profile.a11ySection": "Accessibility",
  "learner.profile.dangerZone": "Danger zone",
  "learner.profile.logoutBtn": "Log out",
  "learner.parcours.title": "My Paths",
  "learner.parcours.assigned": "assigned path(s)",
  "learner.parcours.loading": "Loading your paths…",
  "learner.parcours.loadError": "Unable to load your paths.",
  "learner.parcours.noAssigned": "No assigned path",
  "learner.parcours.noAssignedDesc": "Your instructor will assign paths here.",
  "learner.parcours.completedBadge": "Completed ✓",
  "learner.parcours.by": "By",
  "learner.parcours.contents": "content(s)",
  "learner.parcours.completedItems": "completed",
  "learner.parcours.emptyPath": "No content in this path.",
  "learner.parcours.locked": "Complete the previous one first",
  "learner.parcours.review": "Review",
  "learner.parcours.listen": "Listen",
  "learner.parcours.open": "Open",
  "learner.modal.loading": "Loading…",
  "learner.modal.noEpisodes": "No episode available.",
  "learner.modal.markedDone": "✓ Marked as done",
  "learner.modal.listenThenMark": "Listen then mark as done",
  "learner.modal.alreadyDone": "Already done",
  "learner.modal.markDone": "Mark as done",
  "learner.modal.formationDone": "✓ Course completed",
  "learner.modal.completeThenMark": "Complete the course then mark it as done",
  "learner.modal.formationAlreadyDone": "Already completed",
  "learner.modal.markFormationDone": "Mark as completed",
  "learner.modal.formationInstruction": "Follow the modules of this course in order, then mark it as completed to progress in your path.",
  "learner.modal.launchFormation": "Launch course",
  "learner.modal.openFormationHint": "Open the course in a new tab, then mark it as completed from your path.",
  "learner.home.loadingHome": "Loading your home…",
  "learner.home.noFormationsAssigned": "No course assigned yet. They will appear here when a trainer assigns one to you.",
  "learner.home.loadingPaths": "Loading your paths…",
  "learner.home.noPathsAssigned": "No path assigned yet. They will appear here when a trainer assigns one to you.",
  "learner.home.byTheme": "Your content by theme",
  "learner.home.themesHint": "Themes come from the categories of your assigned courses and podcasts.",
  "learner.home.categoryOther": "Other",
  "learner.home.contentsCount_one": "{{count}} item",
  "learner.home.contentsCount_other": "{{count}} items",
  "learner.home.viewThemeFormations": "View all {{count}} courses in this theme",
  "learner.home.viewThemePodcasts": "View all {{count}} podcasts in this theme",
  "learner.home.resumeSubtitleProgress": "Progress {{percent}}%",
  "learner.home.resumeSubtitleNotStarted": "Not started yet",
  "learner.home.podcastsAssigned": "Assigned podcasts",
  "learner.home.viewAllPodcasts": "See all →",
  "learner.home.gamificationHomeHint": "Badges and full activity are under the « My progress » tab.",
  "learner.home.gamificationHomeCta": "Open my progress",
  "learner.podcasts.mineTitle": "My podcasts",
  "learner.podcasts.episodeCount_one": "{{count}} episode",
  "learner.podcasts.episodeCount_other": "{{count}} episodes",
  "learner.progress.loading": "Loading your progress…",
  "learner.progress.statPodcastsCompleted": "Podcasts completed",
  "learner.progress.statTimeFormationsHours": "Time on courses (h)",
  "learner.progress.statAssignedContents": "Assigned content",
  "learner.progress.weeklyEstimated": "Last 7 days activity (estimated)",
  "learner.progress.badgesSoon": "Badges and rewards will be available in your space soon.",
  "learner.progress.gamificationSection": "Level and experience",
  "learner.progress.gamificationLevelLine": "Level {{level}} — {{name}}",
  "learner.progress.gamificationXpToNext": "{{xp}} XP until the next level",
  "learner.progress.rewardFormation": "Course completed",
  "learner.progress.rewardPathItem": "Learning path step",
  "learner.progress.rewardPathComplete": "Learning path completed",
  "learner.progress.rewardDesignerBlocks": "Course points (completed blocks)",
  "learner.progress.rewardDesignerPerfect": "Perfect quiz score bonus",
  "learner.progress.rewardDesignerBadge": "Course badge",
  "learner.progress.rewardDesignerBadgeNoXp": "No XP points (visual reward)",
  "learner.progress.badgesEmpty": "Complete a course or a learning path to earn points and see your rewards here.",
  "learner.progress.plusXp": "+{{xp}} XP",
  "learner.progress.noRecentHint": "No recent activity yet. Open a course or a podcast to feed this list.",
  "learner.progress.hoursShort": "{{hours}}h",
  "learner.profile.statFormationsRatio": "Courses (completed / total)",
  "learner.profile.statTimeFormations": "Course time (h)",
  "learner.profile.statPodcastsAssigned": "Assigned podcasts",
  "learner.profile.statPathsAssigned": "Assigned paths",
  "learner.profile.memberSincePrefix": "Member since {{date}}",
  "learner.parcours.playPath": "Follow this path",
  "learner.parcours.playPathTitle": "Opens the full-screen path in a new tab",
  "learner.parcours.steps_zero": "No steps",
  "learner.parcours.steps_one": "1 step",
  "learner.parcours.steps_other": "{{count}} steps",
  "learner.parcours.doneBadge": "Done",
  "learner.parcours.completedSingle": "{{done}}/{{total}} completed",
  "learner.parcours.completedPlural": "{{done}}/{{total}} completed",
  "learner.parcours.byAuthor": "By {{firstName}} {{lastName}}",
  "learner.parcours.pathListAria": "Your paths list",
  "learner.parcours.assignedCount_one": "{{count}} assigned path",
  "learner.parcours.assignedCount_other": "{{count}} assigned paths",
  "learner.pathPlayer.loading": "Loading path…",
  "learner.pathPlayer.errorGeneric": "Error",
  "learner.pathPlayer.pathNotFound": "Path not found",
  "learner.pathPlayer.loadError": "Unable to load path.",
  "learner.pathPlayer.backToPaths": "Back to my paths",
  "learner.pathPlayer.showTocAria": "Show outline",
  "learner.pathPlayer.prevActivityAria": "Previous activity",
  "learner.pathPlayer.prev": "Previous",
  "learner.pathPlayer.nextActivityAria": "Next activity",
  "learner.pathPlayer.next": "Next",
  "learner.pathPlayer.closePlayerTitle": "Close and return to paths",
  "learner.pathPlayer.close": "Close",
  "learner.pathPlayer.congrats": "Congratulations",
  "learner.pathPlayer.pathCompleteTitle": "Path completed",
  "learner.pathPlayer.pathCompleteBody": "You have completed all activities in the path “{{title}}”.",
  "learner.pathPlayer.activitiesCompleted_one": "{{count}} activity completed",
  "learner.pathPlayer.activitiesCompleted_other": "{{count}} activities completed",
  "learner.pathPlayer.seeMyPaths": "See my paths",
  "learner.pathPlayer.closeTocAria": "Close outline",
  "learner.pathPlayer.tocNavAria": "Path outline",
  "learner.pathPlayer.pathTypeLabel": "Training path",
  "learner.pathPlayer.noDescription": "No description.",
  "learner.pathPlayer.activityCount_zero": "No activities",
  "learner.pathPlayer.activityCount_one": "1 activity",
  "learner.pathPlayer.activityCount_other": "{{count}} activities",
  "learner.pathPlayer.progressPercent": "Progress {{percent}}%",
  "learner.pathPlayer.quit": "Leave",
  "learner.pathPlayer.summary": "Outline",
  "learner.pathPlayer.outsideModule": "Outside module",
  "learner.pathPlayer.moduleContents": "Module contents",
  "learner.pathPlayer.step": "Step",
  "learner.pathPlayer.podcastHint": "Listen to the episode, then mark the activity as complete.",
  "learner.pathPlayer.showChapters": "Show chapters",
  "learner.pathPlayer.hideChapters": "Hide chapters",
  "learner.pathPlayer.showText": "Show transcript",
  "learner.pathPlayer.hideText": "Hide transcript",
  "learner.pathPlayer.selectEpisode": "Select an episode to start.",
  "learner.pathPlayer.loadingShort": "Loading…",
  "learner.pathPlayer.noEpisodes": "No episodes available.",
  "learner.pathPlayer.listenThenMark": "Listen, then mark as complete",
  "learner.pathPlayer.updating": "Updating…",
  "learner.pathPlayer.alreadyDone": "Already completed",
  "learner.pathPlayer.markComplete": "Mark as complete",
  "learner.pathPlayer.nextStepBtn": "Next step",
  "learner.pathPlayer.embeddedFormationHint": "The course appears below in the path. Use the outline on the left for detailed steps.",
  "learner.pathPlayer.loadingFormation": "Loading course…",
  "learner.pathPlayer.loadingReader": "Loading player…",
  "learner.pathPlayer.emptyPathTitle": "This path does not have any activities yet.",
  "learner.pathPlayer.emptyPathDesc": "Content will be added by your training organization. You can close this window and come back later.",
  "learner.pathPlayer.pickActivity": "Choose an activity in the outline to get started.",
  "learner.pathPlayer.footerStep": "Step {{current}} / {{total}}",
  "learner.pathPlayer.unmute": "Unmute",
  "learner.pathPlayer.mute": "Mute",
  "learner.activity.flowCompleted": "Course “{{title}}” completed",
  "learner.activity.flowProgress": "Course “{{title}}” — {{progress}}%",
  "learner.activity.podcast": "Podcast “{{title}}”",
  "learner.webinars.durationMin": "{{m}} min",
  "learner.webinars.durationH": "{{h}} h",
  "learner.webinars.durationHM": "{{h}} h {{m}}",
  "learner.formations.durationHours": "{{hours}} h",
  "rh.page.documentTitle": "HR dashboard - LyrraOne",
  "rh.dashboard.title": "HR dashboard",
  "rh.dashboard.subtitle": "Training & development overview",
  "rh.dashboard.activeCampaigns": "Active campaigns",
  "rh.dashboard.pendingAssignmentsKpi": "Assignments (pending / accepted)",
  "rh.dashboard.pendingRequestsCount": "Pending requests",
  "rh.dashboard.completionRateLabel": "Completion rate (learning paths)",
  "rh.dashboard.budgetUsed": "Campaign budget used",
  "rh.dashboard.budgetNotSet": "Not set",
  "rh.dashboard.progressLabel": "Progress (%)",
  "rh.dashboard.chartCampaignsTitle": "Campaign progress",
  "rh.dashboard.chartFormationsTitle": "Learning path progress",
  "rh.dashboard.campaignProgress": "Campaign progress",
  "rh.dashboard.chartCampaignsHint": "Average assignment completion rate per campaign.",
  "rh.dashboard.chartFormationsHint": "Share of learners who completed the path (of current enrollments).",
  "rh.dashboard.upcomingDeadlines": "Upcoming deadlines",
  "rh.dashboard.recentActivity": "Recent activity",
  "rh.dashboard.recentActivityHint": "Campaign assignments and completed paths.",
  "rh.dashboard.viewAll": "View all",
  "rh.dashboard.exportReport": "Export report",
  "rh.dashboard.exportSoon": "Export coming soon.",
  "rh.dashboard.newCampaign": "New campaign",
  "rh.dashboard.createCampaign": "Create campaign",
  "rh.dashboard.reviewRequests": "Review requests",
  "rh.dashboard.skillsMap": "Skills framework",
  "rh.dashboard.budgetOverview": "Budget overview",
  "rh.dashboard.loadError": "Could not load HR dashboard.",
  "rh.dashboard.emptyChart": "No data to display yet.",
  "rh.dashboard.emptyDeadlines": "No upcoming campaign deadlines.",
  "rh.dashboard.emptyRecent": "No recent activity.",
  "rh.dashboard.kindAssignment": "Campaign",
  "rh.dashboard.kindCompletion": "Path completed",
  "rh.dashboard.justNow": "Just now",
  "rh.dashboard.learnerInsightTitle": "Training operations (live data)",
  "rh.dashboard.learnerInsightHint": "Aggregated training enrollments: scores from graded blocks, block friction, latest evaluations.",
  "rh.dashboard.enrollmentsTotal": "Enrollments",
  "rh.dashboard.completionGlobal": "Completed",
  "rh.dashboard.avgTimePerEnrollment": "Avg. time per enrollment",
  "rh.dashboard.notStarted": "Not started",
  "rh.dashboard.stalled": "Stalled (>30d inactive after start)",
  "rh.dashboard.topFlowsDetail": "Most subscribed paths",
  "rh.dashboard.colFlow": "Path",
  "rh.dashboard.colEnrolled": "Enrolled",
  "rh.dashboard.colCompletedPct": "Completion",
  "rh.dashboard.colAvgTime": "Avg. time",
  "rh.dashboard.colAvgScore": "Avg. score",
  "rh.dashboard.blockFrictionTitle": "Highest-friction blocks (≥3 sessions)",
  "rh.dashboard.colBlock": "Block",
  "rh.dashboard.colSessions": "Sessions",
  "rh.dashboard.colBlockCompletion": "Block completion",
  "rh.dashboard.recentEvalTitle": "Latest evaluations",
  "rh.dashboard.evalComment": "Has comment",
  "rh.dashboard.exportOk": "CSV downloaded.",
  "rh.dashboard.exportFail": "Download failed.",
  "institution.dashboard.trainingCardTitle": "Training follow-up (enrollments)",
  "institution.dashboard.trainingCardHint": "Aggregated across all institution learning paths.",
  "institution.dashboard.trainingCompleted": "paths completed",
  "institution.dashboard.trainingAvgMinutes": "avg min / enrollment",
  "rh.status.urgent": "Urgent",
  "rh.status.soon": "Soon",
  "rh.status.upcoming": "Upcoming",
  "rh.status.pending": "Pending",
  "rh.status.approved": "Approved",
  "rh.status.rejected": "Rejected",
  "admin.nav.stats": "Statistics",
  "admin.nav.users": "Users",
  "admin.nav.support": "Support & chat",
  "admin.nav.institutions": "Institutions",
  "admin.nav.contracts": "Contracts",
  "admin.nav.editors": "Editors",
  "admin.nav.podcasts": "Podcasts",
  "admin.nav.sounds": "Lyrra sounds",
  "admin.nav.templates": "Course templates",
  "admin.nav.demoFormations": "Demo courses",
  "admin.nav.templatesImages": "Image templates",
  "admin.nav.tools": "Tools",
  "admin.nav.files": "Files",
  "admin.nav.logs": "Logs",
  "admin.nav.webhooks": "Webhooks",
  "admin.nav.email": "Email",
  "admin.nav.docusign": "DocuSign",
  "admin.docusign.title": "DocuSign integration",
  "admin.docusign.subtitle": "Integration key, API identifiers and RSA private key (JWT). Stored in the database, not in Docker.",
  "admin.docusign.statusOk": "Configured",
  "admin.docusign.statusIncomplete": "Incomplete",
  "admin.docusign.keyStored": "Private key on file",
  "admin.docusign.consentHint": "For first-time JWT use, the DocuSign account must grant application consent (URL from DocuSign). If you get 401/403, check the PEM key, integration key and consent.",
  "admin.docusign.loading": "Loading…",
  "admin.docusign.loadError": "Could not load DocuSign settings",
  "admin.docusign.saved": "DocuSign settings saved",
  "admin.docusign.saveError": "Could not save",
  "admin.docusign.save": "Save",
  "admin.docusign.reload": "Reload",
  "admin.docusign.fieldIntegrationKey": "Integration key (client ID)",
  "admin.docusign.fieldUserId": "User ID (GUID)",
  "admin.docusign.fieldAccountId": "Account ID",
  "admin.docusign.fieldBasePath": "REST API base URL",
  "admin.docusign.fieldOauthHost": "OAuth host (without https://)",
  "admin.docusign.fieldRsa": "RSA private key (PEM)",
  "admin.docusign.oauthPlaceholder": "account-d.docusign.com",
  "admin.docusign.rsaPlaceholderKeep": "Leave empty to keep the current key",
  "admin.docusign.rsaPlaceholderNew": "Paste the full .pem file (BEGIN … END)",
  "admin.smtp.cardTitle": "Outbound email (SMTP)",
  "admin.smtp.subtitle": "Host, port, credentials, and sender. Stored in the database — no Docker SMTP_* or EMAIL_FROM variables.",
  "admin.smtp.host": "SMTP host",
  "admin.smtp.port": "Port",
  "admin.smtp.secure": "TLS/SSL (e.g. port 465)",
  "admin.smtp.user": "Username",
  "admin.smtp.password": "Password",
  "admin.smtp.passwordPlaceholder": "Leave empty to keep the current password",
  "admin.smtp.passwordPlaceholderNew": "SMTP password",
  "admin.smtp.fromEmail": "From email",
  "admin.smtp.fromName": "From display name",
  "admin.smtp.hint": "Most providers require a username and password. Use the admin email test tool after saving.",
  "admin.smtp.save": "Save SMTP",
  "admin.smtp.saved": "SMTP settings saved",
  "admin.smtp.saveError": "Could not save",
  "admin.smtp.loadError": "Could not load SMTP settings",
  "admin.smtp.loading": "Loading…",
  "admin.smtp.configured": "Settings saved",
  "admin.smtp.notConfigured": "Incomplete",
  "admin.nav.smtp": "SMTP configuration",
  "admin.nav.regulatoryWatch": "Lyrra regulatory watch",
  "admin.nav.leBref": "Le Bref",
  "admin.nav.helpCenter": "Help center",
  "admin.nav.platform": "Platform integrations",
  "admin.nav.eduflowPalette": "EduFlow palette",
  "admin.users.adminScopeTitle": "Admin dashboard scope",
  "admin.users.adminScopeFull": "Full access (all tabs)",
  "admin.users.adminScopeRestricted": "Restrict to selected tabs",
  "admin.users.adminScopeHint": "Restricted accounts only see the selected sections. After changing tabs, the user must sign in again (or refresh the session) for the menu and API access to update.",
  "admin.users.adminScopeNeedOne": "Select at least one tab, or choose full access.",
  "admin.helpCenter.title": "Help center",
  "admin.helpCenter.subtitle": "Sections shown first on /help and /aide: category, title, short description, and link (/… path or https URL) opened when the card is clicked.",
  "admin.helpCenter.reload": "Refresh",
  "admin.helpCenter.loadError": "Could not load.",
  "admin.helpCenter.saveError": "Could not save.",
  "admin.helpCenter.deleteError": "Could not delete.",
  "admin.helpCenter.saved": "Saved",
  "admin.helpCenter.deleted": "Deleted",
  "admin.helpCenter.catCreated": "Category created",
  "admin.helpCenter.topicCreated": "Article created",
  "admin.helpCenter.catTitleRequired": "Category title is required.",
  "admin.helpCenter.topicFieldsRequired": "Title and formation link are required.",
  "admin.helpCenter.newCategory": "New category",
  "admin.helpCenter.createCategory": "New category",
  "admin.helpCenter.editCategory": "Edit category",
  "admin.helpCenter.createTopic": "New article",
  "admin.helpCenter.editTopic": "Edit article",
  "admin.helpCenter.fieldTitle": "Title",
  "admin.helpCenter.fieldDescription": "Description",
  "admin.helpCenter.fieldIconKey": "Lucide icon",
  "admin.helpCenter.fieldIconKeyHint": "Pick an icon; a preview appears in the list and on the trigger button.",
  "admin.helpCenter.fieldFormationUrl": "Formation link",
  "admin.helpCenter.formationPickPlaceholder": "— Pick a public course —",
  "admin.helpCenter.formationPickHint": "Only published courses with anonymous public access enabled are listed.",
  "admin.helpCenter.formationPickLoading": "Loading courses…",
  "admin.helpCenter.publicFlowsLoadError": "Could not load the list of public courses.",
  "admin.helpCenter.legacyFormationPickLabel": "Saved link (not in list)",
  "admin.helpCenter.fieldSort": "Order",
  "admin.helpCenter.fieldActive": "Visible",
  "admin.helpCenter.save": "Save",
  "admin.helpCenter.edit": "Edit",
  "admin.helpCenter.addTopic": "Article",
  "admin.helpCenter.empty": "No categories yet. Create a category, then articles.",
  "admin.helpCenter.noTopics": "No articles in this category.",
  "admin.helpCenter.badgeActive": "Active",
  "admin.helpCenter.badgeInactive": "Hidden",
  "admin.helpCenter.iconLabel": "Icon",
  "admin.helpCenter.confirmDeleteCategory": "Delete this category and all its articles?",
  "admin.helpCenter.confirmDeleteTopic": "Delete this article?",
  "admin.nav.formationMigration": "Course migration",
  "admin.nav.formationDuplicate": "Duplicate courses",
  "admin.nav.lyrraOneFormations": "LyrraOne courses",
  "admin.lyrraOneFormations.title": "LyrraOne-managed courses",
  "admin.lyrraOneFormations.subtitle": "Assign an EduFlow to LyrraOne: the technical owner is reassigned (PLATFORM_EDUFLOW_OWNER_USER_ID or the first platform admin account), collaborators are removed, and only platform administrators can edit the course in the designer.",
  "admin.lyrraOneFormations.searchLabel": "Search (title or course ID)",
  "admin.lyrraOneFormations.searchPlaceholder": "e.g. onboarding or UUID…",
  "admin.lyrraOneFormations.search": "Search",
  "admin.lyrraOneFormations.searchMin": "Enter at least 2 characters.",
  "admin.lyrraOneFormations.results": "Results",
  "admin.lyrraOneFormations.noResults": "No course found.",
  "admin.lyrraOneFormations.badge": "LyrraOne",
  "admin.lyrraOneFormations.detailHint": "The original author and former collaborators lose edit access. Learners and public playback are not affected.",
  "admin.lyrraOneFormations.assign": "Assign to LyrraOne",
  "admin.lyrraOneFormations.alreadyAssigned": "Already LyrraOne-managed",
  "admin.lyrraOneFormations.confirm": "Confirm LyrraOne assignment? This cannot be undone from here: only platform administrators will be able to edit the course.",
  "admin.lyrraOneFormations.success": "Course \"{{title}}\": LyrraOne assignment completed.",
  "admin.lyrraOneFormations.assignedListTitle": "Courses already assigned to LyrraOne",
  "admin.lyrraOneFormations.assignedListEmpty": "None yet. Use the search below to assign one.",
  "admin.lyrraOneFormations.refreshList": "Refresh list",
  "admin.lyrraOneFormations.openDesigner": "Designer",
  "admin.lyrraOneFormations.assignSectionTitle": "Search and assign another course",
  "admin.lyrraOneFormations.publicPolicyHint": "Courses assigned to LyrraOne are automatically published, anonymously accessible (/f/… short link), and suitable for sharing (QR, help-center iframe).",
  "admin.lyrraOneFormations.drawerTitle": "Public link & QR code",
  "admin.lyrraOneFormations.publicShortLink": "Short link (recommended)",
  "admin.lyrraOneFormations.publicLongLink": "Public player link (UUID)",
  "admin.lyrraOneFormations.copy": "Copy",
  "admin.lyrraOneFormations.copied": "Copied to clipboard.",
  "admin.lyrraOneFormations.copyFailed": "Could not copy (browser or permissions).",
  "admin.lyrraOneFormations.publicLinksUnavailable": "Links unavailable: enable public access or use “Update public access” for courses created before this rule.",
  "admin.lyrraOneFormations.publicIncomplete": "Public access incomplete",
  "admin.lyrraOneFormations.publicRepairHint": "This course is LyrraOne-managed but is missing full public settings (published state, anonymous access, short code).",
  "admin.lyrraOneFormations.publicRepairCta": "Update public access",
  "admin.lyrraOneFormations.publicRepairOk": "Public access applied for “{{title}}”.",
  "admin.formationDuplicate.title": "Duplicate a course to another institution",
  "admin.formationDuplicate.subtitle": "Search for a course, then pick the institution and account that will own the copy. The original course is left unchanged. The copy is a draft (no catalogue, sessions, or collaborators).",
  "admin.formationDuplicate.searchLabel": "Search (title or course ID)",
  "admin.formationDuplicate.searchPlaceholder": "e.g. onboarding or UUID…",
  "admin.formationDuplicate.search": "Search",
  "admin.formationDuplicate.searchMin": "Enter at least 2 characters.",
  "admin.formationDuplicate.results": "Results",
  "admin.formationDuplicate.noResults": "No course found.",
  "admin.formationDuplicate.currentOwner": "Current owner",
  "admin.formationDuplicate.currentInstitution": "Source institution",
  "admin.formationDuplicate.targetInstitution": "Copy destination institution",
  "admin.formationDuplicate.pickInstitution": "Select an institution…",
  "admin.formationDuplicate.newOwner": "Copy owner (trainer / HR)",
  "admin.formationDuplicate.pickOwner": "Select an account…",
  "admin.formationDuplicate.noCandidates": "No eligible account in this institution.",
  "admin.formationDuplicate.duplicate": "Duplicate course",
  "admin.formationDuplicate.confirm": "Create a copy of this course for the selected account? The source course will not be modified.",
  "admin.formationDuplicate.success": "Copy created: \"{{title}}\" for {{email}}. New course ID: {{newFlowId}}.",
  "admin.formationDuplicate.loadInstitutionsError": "Could not load institutions.",
  "admin.formationDuplicate.loadCandidatesError": "Could not load eligible accounts.",
  "admin.formationMigration.title": "Migrate a course between institutions",
  "admin.formationMigration.subtitle": "Search an EduFlow, pick the target institution and an account that can own it (trainer, HR, etc.). Collaborators and course categories are cleared; catalogue links, campaigns and competencies from the previous institution are removed.",
  "admin.formationMigration.searchLabel": "Search (title or course ID)",
  "admin.formationMigration.searchPlaceholder": "e.g. onboarding or UUID…",
  "admin.formationMigration.search": "Search",
  "admin.formationMigration.searchMin": "Enter at least 2 characters.",
  "admin.formationMigration.results": "Results",
  "admin.formationMigration.noResults": "No course found.",
  "admin.formationMigration.currentOwner": "Current owner",
  "admin.formationMigration.currentInstitution": "Source institution",
  "admin.formationMigration.targetInstitution": "Target institution",
  "admin.formationMigration.pickInstitution": "Select an institution…",
  "admin.formationMigration.newOwner": "New owner (trainer / HR)",
  "admin.formationMigration.pickOwner": "Select an account…",
  "admin.formationMigration.noCandidates": "No eligible account in this institution.",
  "admin.formationMigration.migrate": "Migrate course",
  "admin.formationMigration.confirm": "Confirm migration? Collaborators and categories will be cleared; inconsistent HR/catalogue links will be removed.",
  "admin.formationMigration.success": "Done: \"{{title}}\" is now assigned to {{email}}.",
  "admin.formationMigration.clearedCatalog": "Catalogue link removed (item belonged to another institution).",
  "admin.formationMigration.loadInstitutionsError": "Could not load institutions.",
  "admin.formationMigration.loadCandidatesError": "Could not load eligible accounts.",
  "admin.regulatoryWatch.title": "Regulatory watch — LyrraOne alerts",
  "admin.regulatoryWatch.subtitle": "Publish an alert to the “Regulatory watch” timeline of every active institution. Content is locked on the training organisation side; they can acknowledge it, add notes, and plan follow-up.",
  "admin.regulatoryWatch.refresh": "Refresh",
  "admin.regulatoryWatch.loadError": "Could not load data.",
  "admin.regulatoryWatch.validationRequired": "Title, description, and source are required.",
  "admin.regulatoryWatch.publishError": "Could not publish.",
  "admin.regulatoryWatch.newBroadcastTitle": "New global alert",
  "admin.regulatoryWatch.placeholderTitle": "Title",
  "admin.regulatoryWatch.placeholderDescription": "Description (visible to all institutions)",
  "admin.regulatoryWatch.placeholderSource": "Link or source reference",
  "admin.regulatoryWatch.category.reglementaire": "Regulatory",
  "admin.regulatoryWatch.category.pedagogique": "Pedagogical",
  "admin.regulatoryWatch.category.technique": "Technical",
  "admin.regulatoryWatch.category.sectoriel": "Sector",
  "admin.regulatoryWatch.impact.fort": "High impact",
  "admin.regulatoryWatch.impact.moyen": "Medium impact",
  "admin.regulatoryWatch.impact.faible": "Low impact",
  "admin.regulatoryWatch.publishing": "Publishing…",
  "admin.regulatoryWatch.publishButton": "Publish to all active institutions",
  "admin.regulatoryWatch.historyTitle": "History & acknowledgements",
  "admin.regulatoryWatch.loading": "Loading…",
  "admin.regulatoryWatch.empty": "No alerts published yet.",
  "admin.regulatoryWatch.institutionsCount": "{{count}} institution(s)",
  "admin.regulatoryWatch.ackProgress": "Acknowledged: {{ack}}/{{total}} ({{pct}}%)",
  "admin.regulatoryWatch.byAuthor": "By {{who}}",
  "admin.regulatoryWatch.unknownAuthor": "—",
  "admin.leBref.title": "Le Bref — publication calendar",
  "admin.leBref.subtitle": "Daily brief shown on the public page /le-bref. Only one “published” brief per calendar day.",
  "admin.leBref.refresh": "Refresh",
  "admin.leBref.loadError": "Could not load data.",
  "admin.leBref.validationTitle": "Title is required.",
  "admin.leBref.validationBlocks": "Add at least one block (text, audio, quiz, or poll).",
  "admin.leBref.validationBlocksInvalid": "No valid blocks: check quizzes (question + at least 2 answers, valid correct index), audio URLs, and non-empty text.",
  "admin.leBref.blocksHint": "Build the brief with blocks (text, media, quiz, poll — no HTML). Legacy HTML briefs are converted when you open them.",
  "admin.leBref.block.text": "Text",
  "admin.leBref.block.audio": "Audio",
  "admin.leBref.block.quiz": "Quiz",
  "admin.leBref.block.poll": "Poll",
  "admin.leBref.blocksEmpty": "Add blocks (text, audio, quiz, poll). No need to type raw HTML.",
  "admin.leBref.block.moveUp": "Move up",
  "admin.leBref.block.moveDown": "Move down",
  "admin.leBref.block.remove": "Remove block",
  "admin.leBref.block.textPlaceholder": "Paragraph (plain text or line breaks)",
  "admin.leBref.block.audioUrl": "Audio file URL",
  "admin.leBref.block.audioCaption": "Caption (optional)",
  "admin.leBref.block.quizQuestion": "Question",
  "admin.leBref.block.quizOptions": "Answers",
  "admin.leBref.block.optionLabel": "Option",
  "admin.leBref.block.addOption": "Add answer",
  "admin.leBref.block.quizFeedback": "Feedback after check (optional)",
  "admin.leBref.block.pollQuestion": "Poll question",
  "admin.leBref.block.pollMulti": "Allow multiple choices",
  "admin.leBref.block.image": "Image",
  "admin.leBref.block.video": "Video",
  "admin.leBref.block.imageUrl": "Image URL (HTTPS or hosted media)",
  "admin.leBref.block.imageAlt": "Alt text (accessibility)",
  "admin.leBref.block.imageCaption": "Caption below the image (optional)",
  "admin.leBref.block.videoHint": "YouTube, Vimeo, or direct video URL (mp4, WebM…), same idea as the designer video block.",
  "admin.leBref.block.videoUrl": "Video URL",
  "admin.leBref.block.videoPoster": "Poster image URL (optional) — mainly for direct video files",
  "admin.leBref.block.videoCaption": "Title or caption (optional)",
  "admin.leBref.block.audioTtsHint": "Text is read with Mistral TTS; the voice is picked automatically from the text language (same idea as designer audio blocks).",
  "admin.leBref.block.audioTtsPlaceholder": "Text to speak…",
  "admin.leBref.block.audioTtsGenerate": "Synthesize (Mistral TTS)",
  "admin.leBref.block.audioTtsReady": "Audio ready — will be regenerated on save if the text changes.",
  "admin.leBref.block.audioUrlReadonly": "Audio file",
  "admin.leBref.block.audioPreviewUnsupported": "Preview not supported",
  "admin.leBref.block.audioTtsNeedText": "Enter the text to read first.",
  "admin.leBref.block.audioTtsBadResponse": "Invalid TTS response.",
  "admin.leBref.block.audioTtsError": "Synthesis failed (Mistral TTS / integrations).",
  "admin.leBref.saveError": "Could not save.",
  "admin.leBref.deleteError": "Could not delete.",
  "admin.leBref.confirmDelete": "Delete this brief?",
  "admin.leBref.quizJsonInvalid": "Invalid quiz JSON.",
  "admin.leBref.aiError": "AI generation failed (Mistral key / platform integrations).",
  "admin.leBref.prevMonth": "Previous month",
  "admin.leBref.nextMonth": "Next month",
  "admin.leBref.legend": "Legend",
  "admin.leBref.status.published": "Published",
  "admin.leBref.status.draft": "Draft",
  "admin.leBref.status.archived": "Archived",
  "admin.leBref.clickDayHint": "Click a day to start a new brief for that date.",
  "admin.leBref.editBrief": "Edit brief",
  "admin.leBref.newBrief": "New brief",
  "admin.leBref.aiBlockTitle": "AI assistant (Mistral)",
  "admin.leBref.aiThemePlaceholder": "Theme or instructions (e.g. summary + quiz, HR practices poll, article URL, YouTube link…)",
  "admin.leBref.aiContextHint": "State your goal: summary, quiz, opinion poll, audio version, or paste a URL / image or video link — the AI adapts block types (text, audio, image, video, quiz, poll).",
  "admin.leBref.aiGenerate": "Fill with AI",
  "admin.leBref.titlePlaceholder": "Title",
  "admin.leBref.excerptPlaceholder": "Short excerpt",
  "admin.leBref.bodyPlaceholder": "Body (HTML allowed: p, strong, em, ul, li, br)",
  "admin.leBref.audioUrlPlaceholder": "Optional audio URL (mp3, etc.)",
  "admin.leBref.quizPlaceholder": "Optional quiz JSON: {\"questions\":[{\"question\":\"…\",\"options\":[\"A\",\"B\",\"C\",\"D\"],\"correctIndex\":0,\"feedback\":\"…\"}]}",
  "admin.leBref.save": "Save",
  "admin.leBref.create": "Create",
  "admin.leBref.resetForm": "New / clear",
  "admin.leBref.delete": "Delete",
  "admin.leBref.monthListTitle": "Briefs this month",
  "admin.leBref.loading": "Loading…",
  "admin.leBref.emptyMonth": "No briefs in this range.",
  "admin.leBref.edit": "Edit",
  "admin.smtp.pageTitle": "SMTP configuration",
  "admin.smtp.pageHint": "Outgoing server for transactional platform email.",
  "admin.support.linearCreate": "Create Linear issue",
  "admin.support.linearOpen": "Open in Linear",
  "admin.support.linearError": "Could not create the Linear issue. Check LINEAR_API_KEY on the server.",
  "podcasts.pdfImport.openButton": "Import document",
  "podcasts.pdfImport.pickPodcastTitle": "Choose target podcast",
  "podcasts.pdfImport.noPodcast": "Create a non-archived podcast before importing a document.",
  "podcasts.pdfImport.noPodcastMatch": "No podcast matches your search.",
  "podcasts.list.actionImportDocument": "Import document (PDF or Markdown)",
  "podcasts.pdfImport.title": "Import document (PDF or Markdown)",
  "podcasts.pdfImport.subtitle": "Create episodes for « {{podcast}} » from document structure",
  "podcasts.pdfImport.hint": "Content is split: # → episode, ## → chapter, paragraphs → blocks. PDFs are converted to Markdown first for review. Accepted: PDF or .md.",
  "podcasts.pdfImport.convertingPdf": "Converting PDF to Markdown…",
  "podcasts.pdfImport.markdownReviewTitle": "Review generated Markdown",
  "podcasts.pdfImport.markdownReviewSubtitle": "PDF converted for « {{podcast}} ». Edit headings (# / ##) then validate.",
  "podcasts.pdfImport.markdownReviewHint": "Each episode should start with # and each chapter with ##. Fix text before continuing.",
  "podcasts.pdfImport.markdownEditorLabel": "Markdown content",
  "podcasts.pdfImport.markdownEditorHint": "# Episode · ## Chapter · paragraphs = script blocks",
  "podcasts.pdfImport.validateMarkdown": "Validate and view structure",
  "podcasts.pdfImport.editMarkdown": "Edit Markdown",
  "podcasts.pdfImport.markdownEmpty": "Markdown is empty.",
  "podcasts.pdfImport.dropLabel": "Drop a PDF or .md file, or choose a file",
  "podcasts.pdfImport.chooseFile": "Choose file",
  "podcasts.pdfImport.analyzing": "Analyzing document…",
  "podcasts.pdfImport.pageCount": "{{count}} page(s)",
  "podcasts.pdfImport.lineCount": "{{count}} line(s)",
  "podcasts.pdfImport.stats": "{{episodes}} episode(s) · {{chapters}} chapter(s) · {{blocks}} section(s)",
  "podcasts.pdfImport.episodeLabel": "Episode {{index}} — {{title}}",
  "podcasts.pdfImport.sectionsCount": "{{count}} section(s)",
  "podcasts.pdfImport.confirm": "Create episodes",
  "podcasts.pdfImport.importing": "Creating…",
  "podcasts.pdfImport.previewError": "Could not analyze this document.",
  "podcasts.pdfImport.importError": "Import failed.",
  "podcasts.pdfImport.invalidFile": "Only PDF and Markdown (.md) files are accepted.",
  "podcasts.pdfImport.success": "Created {{episodes}} episode(s), {{chapters}} chapter(s), {{blocks}} section(s).",
  "podcasts.pdfImport.hintEditorPage": "After choosing a file, you will open the Markdown editor with a structure assistant (episodes, chapters, alerts).",
  "podcasts.pdfImport.editorPageTitle": "Prepare document import",
  "podcasts.pdfImport.editorPageSubtitle": "Podcast « {{podcast}} » — {{file}}",
  "podcasts.pdfImport.editorEmptyHint": "Choose a PDF or Markdown file to start. Fix structure before creating episodes.",
  "podcasts.pdfImport.backToPodcasts": "Back to podcasts",
  "podcasts.pdfImport.replaceFile": "Replace file",
  "podcasts.pdfImport.documentTitleLabel": "Document title",
  "podcasts.pdfImport.untitledDocument": "Untitled",
  "podcasts.pdfImport.invalidRoute": "Invalid podcast.",
  "podcasts.pdfImport.fixErrorsBeforeImport": "Fix structure errors (right panel) before creating episodes.",
  "podcasts.pdfImport.structurePanelTitle": "Structure assistant",
  "podcasts.pdfImport.structurePanelSubtitle": "Live estimates and alerts while you edit.",
  "podcasts.pdfImport.estimatedStructure": "Estimated structure",
  "podcasts.pdfImport.statEpisodes": "Episodes",
  "podcasts.pdfImport.statChapters": "Chapters",
  "podcasts.pdfImport.statBlocks": "Blocks",
  "podcasts.pdfImport.noPreviewYet": "Add or import content to analyze structure.",
  "podcasts.pdfImport.markdownMeta": "{{lines}} lines · {{h1}} # heading(s) · {{h2}} ## heading(s)",
  "podcasts.pdfImport.structureBlocked": "Errors block import — fix Markdown first.",
  "podcasts.pdfImport.structureReady": "Structure looks good — you can create episodes.",
  "podcasts.pdfImport.structureIssues": "Structure alerts",
  "podcasts.pdfImport.goToLine": "Go to line {{line}} in the editor",
  "podcasts.pdfImport.suggestions": "Suggestions",
  "podcasts.pdfImport.outlinePreview": "Outline preview",
  "podcasts.pdfImport.conceptionGuide": "Structuring guide",
  "podcasts.pdfImport.guideH1": "# Heading 1 = one podcast episode (book chapter, course part, etc.).",
  "podcasts.pdfImport.guideH2": "## Heading 2 = chapter inside the episode (sections, sub-parts).",
  "podcasts.pdfImport.guideBlocks": "Paragraphs and lists = narration blocks for voice-over.",
  "podcasts.pdfImport.guidePdf": "Every PDF is different: always review generated Markdown and adjust # / ## before import.",
  "podcasts.episodeOrder.label": "Episode order",
  "podcasts.episodeOrder.help": "Playback order in the podcast (matches document order on import).",
  "podcasts.episodeOrder.ariaGroup": "Episode order",
  "podcasts.episodeOrder.newestFirst": "Newest → oldest",
  "podcasts.episodeOrder.oldestFirst": "Oldest → newest",
  "podcasts.learner.pageTitle": "Listen to podcast",
  "podcasts.learner.invalidLink": "Invalid or expired link",
  "podcasts.learner.loadError": "Unable to load podcast",
  "podcasts.learner.loading": "Loading podcast…",
  "podcasts.learner.noEpisodes": "No published episode available.",
  "podcasts.learner.listen": "Listen",
  "podcasts.learner.pause": "Pause",
  "podcasts.public": "Podcast",
  "podcasts.public.subscribeButton": "Subscribe for updates",
  "podcasts.public.subscribeModalTitle": "Get new episodes by email",
  "podcasts.public.subscribeModalIntro": "Enter your details. We will email you when a new episode is published.",
  "podcasts.public.fieldFirstName": "First name",
  "podcasts.public.fieldLastName": "Last name",
  "podcasts.public.fieldEmail": "Email",
  "podcasts.public.fieldCompany": "Company (optional)",
  "podcasts.public.submitSubscribe": "Confirm subscription",
  "podcasts.public.cancel": "Cancel",
  "podcasts.public.done": "Done",
  "podcasts.public.subscribeSuccess": "Thank you! You will be notified for each new episode.",
  "podcasts.public.subscribeError": "Could not complete subscription. Please try again later.",
  "podcasts.public.subscribeValidationRequired": "First name, last name and email are required.",
  "podcasts.public.totalDuration": "{{duration}} total",
  "podcasts.public.listenExcerpt": "Listen to excerpt",
  "podcasts.playback.resumeAt": "Resume at {{time}}",
  "podcasts.playback.listened": "Listened",
  "podcasts.playback.listenedCount": "{{count}} listened",
  "podcasts.share.socialNetworksHeading": "Share on social",
  "podcasts.share.shareLinkedIn": "Share on LinkedIn",
  "podcasts.share.shareFacebook": "Share on Facebook",
  "podcasts.share.shareTwitter": "Share on X (Twitter)",
  "podcasts.share.publicShareStatsHeading": "Public page stats",
  "podcasts.share.publicShareStatsVisits": "Visits (public page)",
  "podcasts.share.publicShareStatsLoading": "Loading stats…",
  "podcasts.share.publicShareStatsUnavailable": "Stats unavailable right now.",
  "podcasts.share.publicShareStatsLinkedIn": "LinkedIn",
  "podcasts.share.publicShareStatsFacebook": "Facebook",
  "podcasts.share.publicShareStatsTwitter": "X (Twitter)",
  "podcasts.share.publicSubscribersHeading": "Subscribers (email notifications)",
  "podcasts.share.publicSubscribersEmpty": "No subscribers yet.",
  "podcasts.share.publicSubscribersCompany": "Company",
  "share.publicQrTitle": "Public link QR code",
  "share.publicQrError": "Could not generate the QR code.",
  "share.downloadQrPng": "Download as PNG",
  "learningPaths.card.contents": "{{count}} content items",
  "learningPaths.card.delete": "Delete",
  "learningPaths.card.edit": "Edit",
  "learningPaths.card.learners": "{{count}} learners",
  "learningPaths.card.publish": "Publish",
  "learningPaths.card.unpublish": "Unpublish",
  "learningPaths.card.updatedAt": "Updated {{date}}",
  "learningPaths.createPanel.cancel": "Cancel",
  "learningPaths.createPanel.description": "Name your path; you can add podcasts and courses to it.",
  "learningPaths.createPanel.descriptionLabel": "Description",
  "learningPaths.createPanel.descriptionPlaceholder": "Path goal, target audience…",
  "learningPaths.createPanel.nameLabel": "Path name",
  "learningPaths.createPanel.namePlaceholder": "e.g. HR onboarding path…",
  "learningPaths.createPanel.submit": "Create path",
  "learningPaths.createPanel.title": "New path",
  "learningPaths.deleteDialog.body": "You are about to delete \"{{title}}\". This action cannot be undone.",
  "learningPaths.deleteDialog.cancel": "Cancel",
  "learningPaths.deleteDialog.confirm": "Delete",
  "learningPaths.deleteDialog.title": "Delete path",
  "learningPaths.empty.createFirst": "Create a path",
  "learningPaths.empty.noPathsHint": "Create your first path by combining podcasts and courses.",
  "learningPaths.empty.noPathsYet": "No paths yet",
  "learningPaths.empty.noResults": "No results",
  "learningPaths.empty.noResultsHint": "Adjust your filters or create a new path.",
  "learningPaths.error.loadFailed": "Could not load paths",
  "learningPaths.error.retry": "Retry",
  "learningPaths.filters.allStatuses": "All statuses",
  "learningPaths.filters.draft": "Draft",
  "learningPaths.filters.published": "Published",
  "learningPaths.filters.searchPlaceholder": "Search for a path…",
  "learningPaths.page.newButton": "New path",
  "learningPaths.page.subtitle": "Create ordered training paths",
  "learningPaths.page.title": "Paths",
  "learningPaths.page.totalCount": "{{count}} paths",
  "learningPaths.pagination.next": "Next",
  "learningPaths.pagination.pageOf": "Page {{page}} / {{total}} · {{count}} paths",
  "learningPaths.pagination.previous": "Previous",
  "learningPaths.status.draft": "Draft",
  "learningPaths.status.published": "Published",
  "learningPaths.editor.backToList": "Back to paths",
  "learningPaths.editor.pathNameLabel": "Path name *",
  "learningPaths.editor.idCopyHint": "Path ID (for support)",
  "learningPaths.editor.sectionNavAria": "Path editor sections",
  "learningPaths.editor.tabContents": "Contents",
  "learningPaths.editor.tabLearners": "Learners",
  "webinars.card.exportAttendance": "Download attendance (CSV)",
  "webinars.card.attendanceExportError": "Could not download the attendance file.",
  "webinars.panel.publicFormFixedFieldsHint": "Email and password (min. 8 characters) are always required for participants; add optional or required extra fields here.",
  "webinars.panel.publicFormAddFieldButton": "Add field",
  "webinars.panel.publicFormFieldNumber": "Field {{n}}",
  "webinars.panel.publicFormFieldLabel": "Label shown",
  "webinars.panel.publicFormFieldType": "Type",
  "webinars.panel.publicFormFieldTypeText": "Short text",
  "webinars.panel.publicFormFieldTypeTextarea": "Long text",
  "webinars.panel.publicFormFieldRequired": "Required",
  "webinars.panel.publicFormFieldRemove": "Remove",
  "webinars.panel.publicFormFieldIdHint": "Technical id:",
  "webinars.panel.publicFormFieldLabelRequired": "Each field must have a label.",
  "videos.card.publishedStudio": "Published (editable in Studio)",
  "videos.card.draft": "Draft",
  "videos.page.studioButton": "Studio",
  "videos.studio.title": "Video studio",
  "videos.studio.rail.prep": "Prep",
  "videos.studio.rail.capture": "Capture",
  "videos.studio.rail.post": "Edit",
  "videos.studio.rail.aria": "Video studio steps",
  "videos.studio.badge.setup": "Setup",
  "videos.studio.badge.capture": "Capture",
  "videos.studio.badge.recording": "Recording",
  "videos.studio.badge.post": "Edit",
  "videos.studio.cannotLeaveRecord": "Stop recording before switching step.",
  "videos.studio.railNeedRecording": "Record a video to open the edit step.",
  "videos.studio.sidebar.captureHelp": "Recording captures the entire shared feed (screen, tab, or window). Cropping to the useful area will be done in the Edit step.",
  "videos.studio.sidebar.sources": "Sources",
  "videos.studio.sidebar.recordingLive": "Recording in progress",
  "videos.studio.sidebar.finalizeHint": "Save to your library using the button in the top bar.",
  "videos.studio.canvas.setupEmpty": "Read the side panel, then go to the Capture step.",
  "videos.studio.stepSetup": "Setup",
  "videos.studio.stepCapture": "Capture",
  "videos.studio.stepPost": "Edit",
  "videos.studio.titleLabel": "Video title",
  "videos.studio.titlePlaceholder": "My recording…",
  "videos.studio.saveSetup": "Continue to capture",
  "videos.studio.fieldDescription": "Description",
  "videos.studio.fieldCategories": "Categories",
  "videos.studio.categoriesHint": "One or more categories from your institution (optional).",
  "videos.studio.categoriesEmptyInstitution": "No categories are set up for your institution.",
  "videos.studio.audioTrackPlanned": "Planned audio track",
  "videos.studio.voiceHumanPlan": "Human voice (recorded microphone)",
  "videos.studio.voiceAiPlan": "AI voice (choose for the edit step)",
  "videos.studio.postVoiceHumanKeep": "You chose human voice: the video keeps the microphone audio. Finalize when you are ready.",
  "videos.studio.titleUntitled": "Untitled",
  "videos.studio.voiceAiNoVoices": "No AI voices are available right now.",
  "videos.studio.postVoiceAiPipeline": "AI voice: polish the text, generate the audio track, then apply it to the video.",
  "videos.studio.allowMedia": "Allow screen and microphone",
  "videos.studio.controlsHint": "Tip: to avoid recording this bar, share a tab or a window instead of the full screen, or use a second display. Space = pause / resume when this page is focused.",
  "videos.studio.warnTabOnly": "You selected a single tab: only that tab will be recorded, even if you open other tabs. To capture multiple tabs or windows, restart capture and choose \"Entire Screen\".",
  "videos.studio.templateMenuTitle": "Templates menu",
  "videos.studio.templateEmpty": "No saved template",
  "videos.studio.templatesHintCompact": "Click + to save, apply, or delete a template.",
  "videos.studio.overlayAddMusic": "Background music",
  "videos.studio.musicInvalidType": "Invalid format. Use an audio file (MP3, WAV, M4A, OGG).",
  "videos.studio.musicTooLarge": "Audio file must not exceed 50 MB.",
  "videos.studio.musicDefault": "Music",
  "videos.studio.musicAdded": "Background music added to timeline.",
  "videos.studio.musicUploadError": "Unable to add background music.",
  "videos.studio.layerScreenBorder": "Outer border",
  "videos.studio.layerScreenBorderSize": "Size",
  "videos.studio.layerScreenBorderColor": "Color",
  "videos.studio.layerScreenBorderRadius": "Corner radius",
  "videos.studio.segmentToolsTitle": "Segment tools",
  "videos.studio.segmentZoom": "Zoom",
  "videos.studio.segmentResetView": "Reset view",
  "videos.studio.segmentTransition": "Transition",
  "videos.studio.transitionNone": "None",
  "videos.studio.transitionFade": "Fade",
  "videos.studio.transitionWipeLeft": "Wipe →",
  "videos.studio.transitionSlideUp": "Slide ↑",
  "videos.studio.textEditor.toolbar": "Text formatting",
  "videos.studio.textEditor.bold": "Bold",
  "videos.studio.textEditor.italic": "Italic",
  "videos.studio.textEditor.underline": "Underline",
  "videos.studio.textEditor.textColor": "Text color (selection)",
  "videos.studio.textEditor.size": "Size",
  "videos.studio.textEditor.font": "Font",
  "videos.studio.textEditor.fontFamily.system": "System",
  "videos.studio.textEditor.fontFamily.sansInter": "Sans (Inter)",
  "videos.studio.textEditor.fontFamily.serif": "Serif",
  "videos.studio.textEditor.fontFamily.mono": "Mono",
  "videos.studio.textEditor.fontFamily.script": "Script",
  "videos.studio.controlsHintTab": "You are sharing another tab: the recording does not include this Studio page (so these buttons are not in the video). Keep Studio open in another browser window or on a second screen next to your content. For Pause, Stop, or Done, switch to the window where Studio is open (Alt+Tab or Cmd+Tab). Space only works when the Studio page is focused.",
  "videos.studio.controlsHintMonitor": "You are sharing the full screen: this bar may appear in the recording. Prefer sharing a Tab or Window, or move the controls to another monitor.",
  "videos.studio.controlsHintWindow": "You are sharing one window: the rest of the desktop (and other windows) is usually not recorded. Use the buttons below for Pause, Stop, or Done.",
  "videos.studio.startRecord": "Record",
  "videos.studio.pause": "Pause",
  "videos.studio.resume": "Resume",
  "videos.studio.stop": "Stop",
  "videos.studio.terminer": "Done",
  "videos.studio.processingUpload": "Uploading and transcribing…",
  "videos.studio.timeline": "Playback",
  "videos.studio.transcript": "Recognized text",
  "videos.studio.transcriptRefining": "Refining transcription…",
  "videos.studio.transcriptPlaceholder": "Recognized text from your recording will appear here…",
  "videos.studio.voiceMode": "Audio track",
  "videos.studio.voiceOriginal": "My voice (recorded mic)",
  "videos.studio.voiceAi": "AI voice (Mistral TTS)",
  "videos.studio.voiceSelect": "Voice",
  "videos.studio.polish": "Prepare text for AI voice",
  "videos.studio.generateTts": "Generate voiceover",
  "videos.studio.applyVoiceover": "Apply AI voice to video",
  "videos.studio.preview": "Preview",
  "videos.studio.preview.noFile": "No video file to preview.",
  "videos.studio.bgImage": "Background image",
  "videos.studio.bgImageChoose": "Choose",
  "videos.studio.bgImageInvalidType": "Invalid format. Use an image (PNG, JPG, WebP).",
  "videos.studio.bgImageTooLarge": "Image must not exceed 10 MB.",
  "videos.studio.bgImageLoadError": "Could not load the background image.",
  "videos.studio.bgImageUploading": "Uploading…",
  "videos.studio.bgImageUploadError": "Could not upload the image. Try again.",
  "videos.studio.bgImageLibraryTitle": "Video studio background",
  "videos.studio.postLayoutTitle": "Frame & background",
  "videos.studio.postLayoutHint": "Preview matches the published video: save the draft then publish to apply background, size, and position.",
  "videos.studio.bgImageVideoSize": "Video size",
  "videos.studio.dragToMove": "Drag to move",
  "videos.studio.finalize": "Save to library",
  "videos.studio.saveDraft": "Draft",
  "videos.studio.publish": "Publish",
  "videos.studio.successDraft": "Video saved as draft",
  "videos.studio.successPublish": "Video published to your library",
  "videos.studio.processingPublish": "Processing video…",
  "videos.studio.back": "Back to videos",
  "videos.studio.errorMedia": "Could not access screen or microphone.",
  "videos.studio.errorInsecureContext": "Screen capture requires HTTPS or localhost. Open the app via https:// or http://127.0.0.1 / localhost.",
  "videos.studio.errorNotSupported": "This browser or device does not support screen capture here. Use an up-to-date Chrome or Edge on desktop.",
  "videos.studio.errorMicDenied": "Microphone blocked: allow microphone for this site (lock or info icon in the address bar), then try again.",
  "videos.studio.errorScreenDenied": "Screen sharing denied: pick a screen or tab in the browser dialog and confirm « Share ».",
  "videos.studio.errorMicMissing": "No microphone found. Check hardware and system settings.",
  "videos.studio.errorScreenMissing": "Screen sharing is not available on this device or browser.",
  "videos.studio.errorMicBusy": "Microphone is in use by another app. Close it and try again.",
  "videos.studio.errorScreenBusy": "Could not capture the screen (resource busy). Retry or restart the browser.",
  "videos.studio.errorScreenCancelled": "Screen sharing cancelled.",
  "videos.studio.errorMicCancelled": "Microphone access cancelled.",
  "videos.studio.errorMicGeneric": "Could not access the microphone.",
  "videos.studio.errorScreenGeneric": "Could not capture the screen.",
  "videos.studio.errorScreenEnded": "Screen sharing stopped.",
  "videos.studio.mediaHints": "Chrome or Edge on desktop. If you use http:// with a LAN IP (e.g. 192.168.x.x), capture is often blocked: use http://localhost:5173 or valid HTTPS.",
  "videos.studio.errorRecord": "Recording is not supported in this browser.",
  "videos.studio.errorUpload": "Upload failed.",
  "videos.studio.errorLoadDraft": "Could not load draft.",
  "videos.studio.errorTranscribe": "Transcription unavailable.",
  "videos.studio.errorPolish": "AI polish failed.",
  "videos.studio.errorTts": "Text-to-speech failed.",
  "videos.studio.errorMux": "Audio merge failed.",
  "videos.studio.muxSuccess": "AI voice applied to the video",
  "videos.studio.successFinal": "Video saved to your library",
  "videos.studio.generatingTimeline": "Generating timeline…",
  "videos.studio.crop": "Crop",
  "videos.studio.cropReset": "Reset crop",
  "videos.studio.cropActive": "Crop active — drag or resize the region on the video",
  "videos.studio.cropDone": "Done",
  "videos.studio.cropApplied": "Crop applied",
  "videos.studio.cropEdit": "Edit",
  "videos.studio.cropRemove": "Remove",
  "videos.studio.trimIn": "IN",
  "videos.studio.trimOut": "OUT",
  "videos.studio.trimDuration": "duration",
  "sounds.card.download": "Download",
  "pages.images.copyUrlSuccess": "URL copied to clipboard.",
  "pages.images.copyUrlError": "Could not copy the URL.",
  "pages.images.urlLabel": "Public URL",
  "pages.images.download": "Download",
  "pages.images.downloadSuccess": "Download started.",
  "pages.images.downloadError": "Download failed.",
  "pages.images.viewGrid": "Grid",
  "pages.images.viewList": "List",
  "pages.images.editPanelTitle": "Edit image",
  "pages.images.editPanelSubtitle": "Title, description and file name. Replacing the file keeps the same URL (existing references keep working).",
  "pages.images.replaceFileLabel": "New image file",
  "pages.images.replaceFileHint": "The image is converted to match the current file extension. The public URL does not change.",
  "pages.images.fileOriginalNameLabel": "Original file name",
  "pages.images.saveChanges": "Save",
  "pages.images.saveSuccess": "Image updated.",
  "pages.images.saveError": "Could not save.",
  "pages.images.editAction": "Edit",
  "accessibility.simplifiedTextPageLoading": "Simplifying this page with AI…",
  "accessibility.simplifiedTextPageError": "Unable to simplify this page right now. Please try again in a moment.",
  "accessibility.imageHoverAudio.loading": "Loading audio description…",
  "accessibility.imageHoverAudio.loadingTts": "Generating audio description…",
  "accessibility.imageHoverAudio.loadingVision": "Analyzing image and generating audio…",
  "accessibility.imageHoverAudio.playing": "Playing description…",
  "accessibility.imageHoverAudio.error": "Unable to play audio.",
  "accessibility.imageHoverAudio.unavailable": "Audio description unavailable for this image.",
  "admin.dashboard.monthlyRevenue": "Monthly revenue (€)",
  "admin.dashboard.recentActivity": "Recent activity",
  "admin.dashboard.revenue": "Revenue",
  "admin.dashboard.storageUsed": "Storage used",
  "admin.dashboard.systemHealth": "System health",
  "admin.dashboard.totalUsers": "Total users",
  "admin.dashboard.userGrowth": "User growth",
  "admin.dashboard.vsLastMonth": "vs last month",
  "admin.dashboard.activeToday": "Active today",
  "admin.dashboard.quickActions": "Quick actions",
  "admin.shell.collapse": "Collapse menu",
  "admin.shell.collapseSidebar": "Collapse sidebar",
  "admin.shell.expandSidebar": "Expand sidebar",
  "admin.shell.title": "Administration",
  "admin.header.workspace": "Platform administration",
  "admin.institutionDetail.pageTitle": "Institution — Administration",
  "admin.institutionDetail.backToList": "Back to institutions",
  "auth.acceptTerms": "I accept the",
  "auth.accessDenied": "Access Denied",
  "auth.and": "and",
  "auth.backToLogin": "Back to login",
  "auth.checkInbox": "Check your inbox for a password reset link. It may take a few minutes.",
  "auth.confirmPassword": "Confirm password",
  "auth.confirmRequired": "Please confirm your password",
  "auth.createAccount": "Create your account",
  "auth.email": "Email",
  "auth.emailInvalid": "Invalid email address",
  "auth.emailPassword": "Email & Password",
  "auth.emailRequired": "Email is required",
  "auth.emailSent": "Email sent!",
  "auth.firstName": "First name",
  "auth.firstNameRequired": "Required",
  "auth.forgotError": "Failed to send reset email",
  "auth.forgotPassword": "Forgot password?",
  "auth.forgotPasswordTitle": "Forgot password?",
  "auth.goBack": "Go back",
  "auth.goToLogin": "Go to login",
  "auth.hasAccount": "Already have an account?",
  "auth.hidePassword": "Hide password",
  "auth.institutionRegister": "Inscription Institution",
  "auth.invalidLink": "Invalid reset link",
  "auth.invalidLinkDesc": "This password reset link is invalid or has expired.",
  "auth.invalidToken": "Invalid or expired reset token",
  "auth.lastName": "Last name",
  "auth.lastNameRequired": "Required",
  "auth.loginError": "Login failed. Please check your credentials.",
  "auth.loginOTP": "Login with OTP",
  "auth.loginSubtitle": "Sign in to your LyrraOne account",
  "auth.newPassword": "New password",
  "auth.otpSubtitle": "We sent a 6-digit code to your email",
  "auth.otpTitle": "Enter verification code",
  "auth.password": "Password",
  "auth.passwordMin": "Minimum 8 characters",
  "auth.passwordMismatch": "Passwords do not match",
  "auth.passwordRequired": "Password is required",
  "auth.passwordReset": "Password reset!",
  "auth.passwordResetDesc": "Your password has been successfully updated.",
  "auth.privacy": "Privacy Policy",
  "auth.registerError": "Registration failed",
  "auth.registerSubtitle": "Start creating with LyrraOne",
  "auth.requestNewLink": "Request a new link",
  "auth.resendCode": "Resend code",
  "auth.resendIn": "Resend code in",
  "auth.resetError": "Failed to reset password",
  "auth.resetPassword": "Reset password",
  "auth.resetPasswordSubtitle": "Choose a strong password for your account",
  "auth.resetPasswordTitle": "Set new password",
  "auth.sendOTP": "Send OTP code",
  "auth.sendResetLink": "Send reset link",
  "auth.showPassword": "Show password",
  "auth.terms": "Terms of Service",
  "auth.termsRequired": "You must accept the terms",
  "auth.welcomeBack": "Welcome back",
  "campaign.analytics.avgProgress": "Progression moy.",
  "campaign.analytics.avgProgressChart": "Progression moyenne",
  "campaign.analytics.completion": "Taux de complétion",
  "campaign.analytics.completionPct": "Complétion %",
  "campaign.analytics.completionRate": "Taux de complétion",
  "campaign.analytics.now": "Actuel",
  "campaign.analytics.totalParticipants": "Participants",
  "campaign.budget.none": "Aucun budget renseigné.",
  "campaign.budget.title": "Budget prévu",
  "campaign.col.participant": "Participant",
  "campaign.col.progress": "Progression",
  "campaign.col.status": "Statut",
  "campaign.content.placeholderTitle": "Contenus pédagogiques",
  "campaign.detail.actionError": "Action impossible.",
  "campaign.detail.back": "Retour aux campagnes",
  "campaign.detail.cancel": "Annuler",
  "campaign.detail.complete": "Clôturer",
  "campaign.detail.description": "Description",
  "campaign.detail.launch": "Lancer",
  "campaign.detail.loadError": "Impossible de charger la campagne.",
  "campaign.detail.missingId": "Identifiant manquant.",
  "campaign.detail.noDescription": "Aucune description.",
  "campaign.detail.timeline": "Calendrier",
  "campaign.participants.empty": "Aucun participant assigné.",
  "campaign.participants.unknown": "Inconnu",
  "campaign.stats.completed": "Terminés",
  "campaign.stats.enrolled": "Inscrits",
  "campaign.stats.inProgress": "En cours",
  "campaign.stats.notStarted": "Non démarrés",
  "campaign.tab.analytics": "Analytique",
  "campaign.tab.budget": "Budget",
  "campaign.tab.content": "Contenu",
  "campaign.tab.overview": "Vue d’ensemble",
  "campaign.tab.participants": "Participants",
  "campaign.timeline.end": "Fin prévue",
  "campaign.timeline.start": "Début de campagne",
  "campaigns.col.budget": "Budget",
  "campaigns.col.completion": "Completion",
  "campaigns.col.enrolled": "Enrolled",
  "campaigns.col.name": "Name",
  "campaigns.col.period": "Period",
  "campaigns.col.status": "Status",
  "campaigns.create.budget": "Budget (€)",
  "campaigns.create.budgetPlaceholder": "25000",
  "campaigns.create.departments": "Departments",
  "campaigns.create.description": "Description",
  "campaigns.create.endDate": "End date",
  "campaigns.create.error": "Could not create campaign.",
  "campaigns.create.individualSearchPlaceholder": "Search people...",
  "campaigns.create.individuals": "Individuals",
  "campaigns.create.launch": "Launch campaign",
  "campaigns.create.launchNote": "Launching notifies all participants and starts the campaign on the selected start date.",
  "campaigns.create.name": "Campaign name",
  "campaigns.create.namePlaceholder": "e.g. Leadership 2025",
  "campaigns.create.review": "Review",
  "campaigns.create.reviewFieldBudget": "Budget",
  "campaigns.create.reviewFieldName": "Name",
  "campaigns.create.reviewFieldPeriod": "Period",
  "campaigns.create.reviewContentItems": "Training content",
  "campaigns.create.contentSelected": "{{count}} selected",
  "campaigns.create.selectContent": "Select training content",
  "campaigns.create.startDate": "Start date",
  "campaigns.create.steps.audience": "Target audience",
  "campaigns.create.steps.basic": "Basic information",
  "campaigns.create.steps.content": "Content",
  "campaigns.create.steps.review": "Review & launch",
  "campaigns.create.title": "Create campaign",
  "campaigns.dept.engineering": "Engineering",
  "campaigns.dept.product": "Product",
  "campaigns.dept.sales": "Sales",
  "campaigns.dept.marketing": "Marketing",
  "campaigns.dept.finance": "Finance",
  "campaigns.dept.legal": "Legal",
  "campaigns.dept.hr": "Human resources",
  "campaigns.list.create": "New campaign",
  "campaigns.list.empty": "No campaigns found.",
  "campaigns.list.loadError": "Unable to load campaigns.",
  "campaigns.list.results": "campaigns",
  "campaigns.list.search": "Search campaigns...",
  "campaigns.list.title": "Campaigns",
  "campaigns.page.documentTitle": "Campaigns - LyrraOne",
  "campaigns.sort.completion": "Completion",
  "campaigns.sort.enrolled": "Enrolled",
  "campaigns.sort.name": "Name",
  "campaigns.sort.startDate": "Start date",
  "campaigns.status.active": "Active",
  "campaigns.status.all": "All",
  "campaigns.status.cancelled": "Cancelled",
  "campaigns.status.completed": "Completed",
  "campaigns.status.draft": "Draft",
  "campaigns.status.paused": "Paused",
  "campaigns.status.scheduled": "Scheduled",
  "campaigns.validation.budgetRequired": "Budget is required.",
  "campaigns.validation.endDateRequired": "End date is required.",
  "campaigns.validation.nameRequired": "Campaign name is required.",
  "campaigns.validation.startDateRequired": "Start date is required.",
  "catalog.backToCatalog": "Retour au catalogue",
  "catalog.categories": "Catégories",
  "catalog.category": "Catégorie",
  "catalog.detailLoadError": "Impossible de charger la formation.",
  "catalog.enrollError": "Inscription impossible.",
  "catalog.enrollOk": "Inscription enregistrée.",
  "catalog.enrollments": "insc.",
  "catalog.flowFromTeacher": "Parcours formateur",
  "catalog.format": "Format",
  "catalog.language": "Langue",
  "catalog.loadError": "Impossible de charger le catalogue.",
  "catalog.missingId": "Identifiant manquant.",
  "catalog.noObjectives": "Aucune compétence liée.",
  "catalog.noResults": "Aucune formation ne correspond à vos critères.",
  "catalog.objectives": "Objectifs / compétences",
  "catalog.prerequisites": "Prérequis",
  "catalog.prerequisitesPlaceholder": "Les prérequis détaillés seront affichés lorsque renseignés sur la fiche.",
  "catalog.related": "Formations populaires",
  "catalog.results": "formation(s)",
  "catalog.search": "Rechercher une formation…",
  "catalog.sortDuration": "Durée",
  "catalog.sortName": "Nom",
  "catalog.sortPopular": "Popularité",
  "catalog.sortRating": "Note",
  "certificate.completed": "has successfully completed",
  "certificate.date": "Date",
  "certificate.download": "Download PDF",
  "certificate.title": "Certificate of Completion",
  "certificate.verification": "Verification",
  "certification.completeToUnlock": "Complétez toutes les étapes pour débloquer votre certificat.",
  "certification.download": "Télécharger",
  "certification.earned": "Certification obtenue",
  "certification.locked": "Verrouillé",
  "certification.milestones": "étapes",
  "certification.preview": "Certificat",
  "certification.requirements": "Prérequis à valider :",
  "certification.subtitle": "Suivez votre progression vers vos certifications professionnelles.",
  "certification.title": "Parcours de certification",
  "codir.card.budgetAllocated": "Budget alloué (année)",
  "codir.card.campaigns": "Campagnes actives",
  "codir.card.completionYtd": "Taux complétion (année)",
  "codir.card.costPerUser": "Coût / utilisateur (estim.)",
  "codir.card.used": "utilisé",
  "codir.dashboard.budgetOverview": "Budget (année en cours)",
  "codir.dashboard.competencyGaps": "Écarts compétences critiques",
  "codir.dashboard.completionTrends": "Achèvements par mois",
  "codir.dashboard.completionsPerMonth": "Achèvements / mois",
  "codir.dashboard.deptPerformance": "Budget par direction",
  "codir.dashboard.loadError": "Impossible de charger le tableau de bord.",
  "codir.dashboard.noBudget": "Non renseigné",
  "codir.dashboard.noDeptData": "Aucune ligne budgétaire",
  "codir.dashboard.noGaps": "Aucun écart critique recensé.",
  "codir.dashboard.remaining": "Restant",
  "codir.dashboard.spent": "Consommé",
  "codir.dashboard.strategicKPIs": "Indicateurs clés",
  "codir.dashboard.subtitle": "Indicateurs formation et budget",
  "codir.dashboard.title": "Tableau de bord CODIR",
  "codir.dashboard.totalBudget": "Budget total",
  "codir.dashboard.utilization": "Utilisation %",
  "codir.kpi.budget": "Budget consommé",
  "codir.kpi.completion": "Complétion",
  "codir.kpi.recentCompletions": "Achèvements 30 j.",
  "codir.kpi.satisfaction": "Satisfaction",
  "collab.certificates.active": "actif(s)",
  "collab.certificates.empty": "Aucun certificat pour ce filtre.",
  "collab.certificates.expires": "Expire le",
  "collab.certificates.issued": "Délivré le",
  "collab.certificates.title": "Mes certificats",
  "collab.certificates.verify": "Vérifier",
  "collab.dashboard.activeTrainings": "Formations en cours",
  "collab.dashboard.certificates": "Certificats",
  "collab.dashboard.completed": "Terminées",
  "collab.dashboard.level": "Niveau",
  "collab.dashboard.noActiveTrainings": "Aucune formation en cours.",
  "collab.dashboard.noCompleted": "Aucune formation terminée.",
  "collab.dashboard.noUpcoming": "Aucune formation à venir.",
  "collab.dashboard.title": "Mes formations",
  "collab.dashboard.totalXp": "XP Total",
  "collab.dashboard.upcoming": "À venir",
  "collab.page.documentTitle": "My training - LyrraOne",
  "collab.page.subtitle": "Track your progress and manage your training",
  "collab.page.tabs.certificates": "Certificates",
  "collab.page.tabs.dashboard": "Dashboard",
  "collab.page.tabs.request": "Make a request",
  "collab.page.tabs.skills": "My skills",
  "collab.page.title": "My training",
  "collab.request.history": "Historique de mes demandes",
  "collab.request.justification": "Justification",
  "collab.request.justificationPlaceholder": "Expliquez pourquoi cette formation est nécessaire (min. 10 caractères)…",
  "collab.request.newRequest": "Nouvelle demande",
  "collab.request.noHistory": "Aucune demande pour le moment.",
  "collab.request.preferredDate": "Date souhaitée",
  "collab.request.searchCatalog": "Rechercher dans le catalogue…",
  "collab.request.submit": "Envoyer la demande",
  "collab.request.title": "Demander une formation",
  "collab.request.training": "Formation",
  "collab.skills.current": "Niveau actuel",
  "collab.skills.empty": "Aucune compétence renseignée.",
  "collab.skills.emptyHint": "Vos compétences apparaîtront ici une fois ajoutées.",
  "collab.skills.radar": "Radar de compétences",
  "collab.skills.selfAssess": "Auto-évaluation",
  "collab.skills.target": "Objectif",
  "collab.skills.title": "Mes compétences",
  "common.back": "Back",
  "common.collaborator": "Collaborateur",
  "common.comingSoon": "En construction",
  "common.comment": "Commentaire",
  "common.comments": "Comments",
  "common.complete": "Complete",
  "common.confirm": "Confirmer",
  "common.cost": "Coût",
  "common.current": "Current",
  "common.date": "Date souhaitée",
  "common.description": "Description",
  "common.download": "Télécharger",
  "common.invalidEmail": "Invalid email",
  "common.justification": "Justification",
  "common.managerComment": "Commentaire manager",
  "common.moveDown": "Descendre",
  "common.moveUp": "Monter",
  "common.next": "Suivant",
  "common.noExpiry": "Sans expiration",
  "common.noResults": "Aucun résultat",
  "common.overall": "Global",
  "common.previous": "Précédent",
  "common.read": "read",
  "common.remove": "Supprimer",
  "common.required": "Required",
  "common.restore": "Restore",
  "common.retry": "Réessayer",
  "common.seeAll": "See all",
  "common.select": "Select...",
  "common.share": "Partager",
  "common.startedOn": "Started on",
  "common.status": "Statut",
  "common.submit": "Submit",
  "common.submittedAt": "Soumis le",
  "common.training": "Formation",
  "common.view": "Consulter",
  "common.words": "words",
  "compliance.download": "Télécharger",
  "compliance.generate": "Générer",
  "compliance.generating": "Génération…",
  "compliance.lastGenerated": "Généré le",
  "compliance.subtitle": "Générez et gérez vos documents réglementaires et pédagogiques.",
  "compliance.title": "Documents de conformité",
  "compliance.uploadEvidence": "Importer un justificatif",
  "confirmDialog.cancel": "Cancel",
  "confirmDialog.confirm": "Confirm",
  "dashboard.collaborators": "Collaborateurs",
  "dysModule.font": "OpenDyslexic",
  "dysModule.letter": "Aa",
  "dysModule.ruler": "Ruler",
  "dysModule.settings": "Dyslexia settings",
  "dysModule.word": "W",
  "eduflow.answerSubmitted": "✓ Answer submitted successfully",
  "eduflow.contents": "Contents",
  "eduflow.correct": "✓ Correct!",
  "eduflow.evaluation": "Evaluation",
  "eduflow.evaluationSubmitted": "Evaluation submitted",
  "eduflow.form": "Form",
  "eduflow.formSubmitted": "Form submitted",
  "eduflow.incorrect": "✗ Incorrect. Try again.",
  "eduflow.mindmap": "Mindmap",
  "eduflow.next": "Suivant",
  "eduflow.openQuestion": "Open Question",
  "eduflow.phraseReveal.addPhrase": "Ajouter une phrase",
  "eduflow.phraseReveal.autoScroll": "Défilement automatique",
  "eduflow.phraseReveal.displayDuration": "Durée par phrase (s)",
  "eduflow.phraseReveal.emptyPhrase": "Phrase vide",
  "eduflow.phraseReveal.noPhrases": "Aucune phrase pour l’instant.",
  "eduflow.phraseReveal.phraseContent": "Contenu de la phrase",
  "eduflow.phraseReveal.phrasePlaceholder": "Saisissez le texte de cette étape…",
  "eduflow.phraseReveal.showHistory": "Afficher l’historique des phrases",
  "eduflow.quiz": "Quiz",
  "eduflow.readComplete": "Read complete",
  "eduflow.takeNotes": "Take notes...",
  "eduflow.timeline.addEvent": "Événement",
  "eduflow.timeline.alternatingSides": "Côtés alternés",
  "eduflow.timeline.animatedReveal": "Révélation animée",
  "eduflow.timeline.colorHint": "Couleur du point (optionnel)",
  "eduflow.timeline.colorLabel": "Couleur",
  "eduflow.timeline.datePlaceholder": "Date ou période (ex. 1789, janv. 2024)",
  "eduflow.timeline.descPlaceholder": "Description (affichée au développement)",
  "eduflow.timeline.events": "Événements",
  "eduflow.timeline.horizontal": "Horizontale",
  "eduflow.timeline.orientation": "Orientation",
  "eduflow.timeline.settings": "Paramètres",
  "eduflow.timeline.showConnectors": "Lignes de connexion",
  "eduflow.timeline.untitled": "Sans titre",
  "eduflow.timeline.vertical": "Verticale",
  "eduflow.typeAnswer": "Type your answer...",
  "eduflow.videoCompleted": "Video watched",
  "gamification.active": "actives",
  "gamification.bestStreak": "Meilleur streak",
  "gamification.claim": "Récupérer",
  "gamification.completed": "Terminées",
  "gamification.days": "jours",
  "gamification.maxLevel": "✨ Niveau max atteint !",
  "gamification.missions": "Missions",
  "gamification.name": "Nom",
  "gamification.streakActive": "Streak en cours 🔥",
  "gamification.streakInactive": "Pas de streak actif",
  "gamification.xpRemaining": "${formatXp(xpForNextLevel - currentXp)} XP restants",
  "institution.categories.color": "Couleur",
  "institution.categories.coverLabel": "Image de couverture",
  "institution.categories.coverUploadError": "Échec du téléversement de la couverture.",
  "institution.categories.removeCover": "Retirer l’image",
  "institution.categories.descShortPh": "Décrivez l’usage de la catégorie",
  "institution.categories.edit": "Modifier la catégorie",
  "institution.categories.episodes": "épisode(s)",
  "institution.categories.learners": "apprenant(s)",
  "institution.categories.namePlaceholder": "Nom de la catégorie",
  "institution.categories.new": "Nouvelle catégorie",
  "institution.categories.preview": "Aperçu",
  "institution.categories.previewApiModeOff": "Prévisualisation indisponible (mode local).",
  "institution.categories.previewDesc": "Podcasts et parcours reliés à cette catégorie.",
  "institution.categories.previewError": "Erreur lors du chargement de l’aperçu.",
  "institution.categories.previewFormations": "Parcours / formations",
  "institution.categories.previewLoading": "Chargement de l’aperçu…",
  "institution.categories.previewNoFlows": "Aucune formation rattachée à cette catégorie.",
  "institution.categories.previewNoPodcasts": "Aucun podcast rattaché à cette catégorie.",
  "institution.categories.previewPodcasts": "Podcasts",
  "institution.categories.saveError": "Erreur lors de la sauvegarde.",
  "institution.categories.subscribers": "abonné(s)",
  "institution.categories.usageItems": "élément(s)",
  "institution.common.add": "Ajouter",
  "institution.common.cancel": "Annuler",
  "institution.common.close": "Fermer",
  "institution.common.delete": "Supprimer",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.loading": "Chargement…",
  "institution.common.name": "Nom",
  "institution.common.refresh": "Actualiser",
  "institution.common.required": "Requis",
  "institution.common.retry": "Réessayer",
  "institution.common.save": "Enregistré",
  "institution.contentPipeline.confirmDeletePath": "Supprimer ce parcours ?",
  "institution.contentPipeline.createPath": "Créer le parcours",
  "institution.contentPipeline.createPodcast": "Créer le podcast",
  "institution.contentPipeline.createShell": "Créer la fiche",
  "institution.contentPipeline.descPh": "Description / objectifs",
  "institution.contentPipeline.newPath": "Nouveau parcours",
  "institution.contentPipeline.newPodcastShell": "Pré-créer un podcast",
  "institution.contentPipeline.newShell": "Nouvelle fiche formation",
  "institution.contentPipeline.openDesigner": "Ouvrir dans le designer",
  "institution.contentPipeline.openStudio": "Épisodes",
  "institution.contentPipeline.pathDescLabel": "Description",
  "institution.contentPipeline.pathPlannedLaunch": "Date cible de lancement",
  "institution.contentPipeline.pathTitlePh": "Titre du parcours",
  "institution.contentPipeline.pickProducer": "Assigner producteur…",
  "institution.contentPipeline.pickTeacher": "Assigner…",
  "institution.contentPipeline.plannedDeadline": "Échéance",
  "institution.contentPipeline.plannedStart": "Début prévu",
  "institution.contentPipeline.planningColumn": "Planning création",
  "institution.contentPipeline.planningOptional": "Planning de création (optionnel)",
  "institution.contentPipeline.podDescPh": "Brief / description pour le formateur",
  "institution.contentPipeline.savePlanning": "Enregistrer le planning",
  "institution.contentPipeline.statFormations": "Fiches catalogue",
  "institution.contentPipeline.statPaths": "Parcours certifiants",
  "institution.contentPipeline.statPodcasts": "Podcasts",
  "institution.contentPipeline.tabFormations": "Fiches formations",
  "institution.contentPipeline.tabPaths": "Parcours",
  "institution.contentPipeline.tabPodcasts": "Podcasts",
  "institution.contentPipeline.title": "Préparation du contenu",
  "institution.contentPipeline.titlePh": "Titre",
  "institution.learnerAnalytics.chartActivity": "Activité et complétions (8 dernières semaines)",
  "institution.learnerAnalytics.chartProgress": "Progression globale (par apprenant)",
  "institution.learnerAnalytics.chartStatus": "Répartition par statut",
  "institution.learnerAnalytics.chartTopFlows": "Formations les plus suivies",
  "institution.learnerAnalytics.colDone": "Terminé",
  "institution.learnerAnalytics.colFlow": "Formation",
  "institution.learnerAnalytics.colLastAccess": "Dernier accès",
  "institution.learnerAnalytics.colName": "Apprenant",
  "institution.learnerAnalytics.colTime": "Temps",
  "institution.learnerAnalytics.count": "Effectif",
  "institution.learnerAnalytics.done": "Terminés",
  "institution.learnerAnalytics.enrolled": "Inscrits",
  "institution.learnerAnalytics.kpiEnrollments": "Inscriptions",
  "institution.learnerAnalytics.kpiLearners": "Apprenants",
  "institution.learnerAnalytics.kpiLearnersSub": "Participants enregistrés",
  "institution.learnerAnalytics.kpiRate": "Taux de complétion",
  "institution.learnerAnalytics.kpiRateSub": "Sur l’ensemble des inscriptions",
  "institution.learnerAnalytics.kpiTime": "Temps cumulé",
  "institution.learnerAnalytics.kpiTimeSub": "Temps passé sur les parcours",
  "institution.learnerAnalytics.loadError": "Impossible de charger les analyses.",
  "institution.learnerAnalytics.noData": "Pas encore de données.",
  "institution.learnerAnalytics.seriesActivity": "Accès (inscriptions)",
  "institution.learnerAnalytics.seriesCompletions": "Complétions",
  "institution.learnerAnalytics.tableEmpty": "Aucune ligne à afficher.",
  "institution.learnerAnalytics.tableSearch": "Rechercher nom, email, formation…",
  "institution.learnerAnalytics.tableTitle": "Détail des inscriptions",
  "institution.learnerAnalytics.tableTruncated": "Affichage limité à 500 lignes — utilisez l’export pour la liste complète.",
  "institution.learnerAnalytics.title": "Analyse & suivi des apprenants",
  "institution.learnerAnalytics.xapiDataSourceTitle": "Source des données & xAPI",
  "institution.learners.flowDone": "Terminé",
  "institution.learners.inProgress": "En cours",
  "institution.menuBlocked.title": "Fonctionnalité non disponible",
  "institution.rhModule.pickFromMenu": "Choisissez un outil dans le menu Formation & RH.",
  "institution.sirh.apiKey": "Clé API",
  "institution.sirh.apiKeyStored": "déjà enregistrée — laissez vide pour ne pas changer",
  "institution.sirh.apiSecret": "Secret / second jeton (optionnel)",
  "institution.sirh.apiSecretHint": "Envoyé en en-tête X-API-Secret si renseigné.",
  "institution.sirh.baseUrl": "URL de base de l’API",
  "institution.sirh.baseUrlHint": "Lyrra appellera GET {URL}/employees avec Authorization: Bearer &lt;clé API&gt;.",
  "institution.sirh.enabled": "Synchronisation activée",
  "institution.sirh.formatTitle": "Format attendu pour GET /employees",
  "institution.sirh.loadError": "Impossible de charger la configuration SIRH.",
  "institution.sirh.mappingJob": "Poste / fonction (jobTitle ou ex. position)",
  "institution.sirh.mappingTitle": "Correspondance des champs (JSON SIRH)",
  "institution.sirh.name": "Libellé interne",
  "institution.sirh.saveError": "Enregistrement impossible.",
  "institution.sirh.saved": "Configuration enregistrée.",
  "institution.sirh.secretStored": "déjà enregistré",
  "institution.sirh.syncDone": "Synchronisation : ${s.created} créés, ${s.updated} mis à jour, ${s.errors} erreurs, ${s.skipped} ignorés (autre établissement).",
  "institution.sirh.syncError": "Synchronisation impossible.",
  "institution.sirh.syncNow": "Synchroniser les collaborateurs",
  "institution.sirh.syncOk": "Synchronisation terminée.",
  "institution.sirh.test": "Tester la connexion",
  "institution.sirh.testError": "Test impossible.",
  "institution.sirh.title": "SIRH — connexion API",
  "institution.sirh.type": "Type / famille",
  "institution.sirh.typeCustom": "API HTTP personnalisée",
  "institution.ssoOidc.autoProvision": "Créer automatiquement les comptes à la première connexion (si pris en charge)",
  "institution.ssoOidc.clientId": "Client ID",
  "institution.ssoOidc.clientSecret": "Client secret",
  "institution.ssoOidc.copied": "Copié",
  "institution.ssoOidc.copy": "Copier",
  "institution.ssoOidc.copyError": "Copie impossible.",
  "institution.ssoOidc.defaultRole": "Rôle par défaut (provisionnement)",
  "institution.ssoOidc.enableSsoGeneric": "Activer le SSO pour cet établissement",
  "institution.ssoOidc.flagsError": "Mise à jour des options impossible.",
  "institution.ssoOidc.flagsSuccess": "Options SSO mises à jour.",
  "institution.ssoOidc.formTitle": "Identifiants OpenID Connect",
  "institution.ssoOidc.issuer": "Issuer (URL)",
  "institution.ssoOidc.loadError": "Impossible de charger la configuration SSO.",
  "institution.ssoOidc.optionsTitle": "Activation et provisionnement",
  "institution.ssoOidc.pageTitle": "SSO — OpenID Connect & SAML 2.0",
  "institution.ssoOidc.redirectTitle": "URL de redirection (callback)",
  "institution.ssoOidc.saveCredentials": "Enregistrer les identifiants",
  "institution.ssoOidc.saveError": "Enregistrement impossible.",
  "institution.ssoOidc.saveOptions": "Enregistrer les options",
  "institution.ssoOidc.saveSuccess": "Configuration OpenID Connect enregistrée.",
  "institution.ssoOidc.scopes": "Scopes (séparés par un espace)",
  "institution.ssoOidc.secretOptional": "laisser vide pour conserver l’actuel",
  "institution.ssoOidc.secretRequired": "Indiquez le secret client (première configuration).",
  "institution.ssoOidc.tablistAria": "Protocole SSO",
  "institution.ssoSaml.acsTitle": "URL Assertion Consumer Service (ACS)",
  "institution.ssoSaml.certOptional": "laisser vide pour conserver l’actuel",
  "institution.ssoSaml.certificate": "Certificat de signature IdP (PEM)",
  "institution.ssoSaml.copied": "Copié",
  "institution.ssoSaml.copy": "Copier",
  "institution.ssoSaml.copyError": "Copie impossible.",
  "institution.ssoSaml.downloadError": "Téléchargement des métadonnées SP impossible.",
  "institution.ssoSaml.downloadSp": "Métadonnées SP (XML)",
  "institution.ssoSaml.entityId": "Entity ID (Issuer IdP)",
  "institution.ssoSaml.manualTitle": "Paramètres IdP (manuel)",
  "institution.ssoSaml.metadataEmpty": "Collez le XML des métadonnées IdP.",
  "institution.ssoSaml.metadataError": "Import des métadonnées impossible.",
  "institution.ssoSaml.metadataFormTitle": "Importer les métadonnées IdP (XML)",
  "institution.ssoSaml.metadataStored": "Un fichier de métadonnées IdP est déjà stocké.",
  "institution.ssoSaml.metadataSuccess": "Métadonnées SAML IdP enregistrées.",
  "institution.ssoSaml.metadataUrl": "URL des métadonnées IdP (optionnel)",
  "institution.ssoSaml.saveError": "Enregistrement SAML impossible.",
  "institution.ssoSaml.saveManual": "Enregistrer la configuration SAML",
  "institution.ssoSaml.saveSuccess": "Configuration SAML enregistrée.",
  "institution.ssoSaml.sloUrl": "URL de déconnexion SLO (optionnel)",
  "institution.ssoSaml.ssoUrl": "URL de connexion SSO (IdP)",
  "institution.ssoSaml.uploadMetadata": "Enregistrer le XML IdP",
  "institution.templates.blockType": "Type de bloc",
  "institution.templates.create": "Créer un modèle",
  "institution.templates.createDrawerTitle": "Créer un modèle de bloc",
  "institution.templates.createNameRequired": "Veuillez renseigner le titre du modèle.",
  "institution.templates.editDrawerTitle": "Modifier le modèle",
  "institution.templates.modelDescPh": "Description du modèle",
  "institution.templates.modelNamePh": "Titre du modèle",
  "institution.templates.previewDrawerTitle": "Aperçu du modèle",
  "institution.templates.publish": "Publier",
  "institution.templates.published": "Publié",
  "institution.templates.typeConfig": "Configuration du bloc",
  "institution.templates.unpublish": "Dépublier",
  "institution.xapi.accessToken": "Jeton d’accès (Bearer)",
  "institution.xapi.actorField": "Champ acteur (référence)",
  "institution.xapi.authBasic": "HTTP Basic (utilisateur / mot de passe)",
  "institution.xapi.authBearer": "Bearer / jeton OAuth",
  "institution.xapi.authType": "Authentification LRS",
  "institution.xapi.enable": "Activer l’envoi des statements vers le LRS",
  "institution.xapi.formTitle": "Paramètres LRS",
  "institution.xapi.loadError": "Impossible de charger la configuration xAPI.",
  "institution.xapi.loadStatements": "Afficher 15 statements (JSON)",
  "institution.xapi.lrsReadTitle": "Lecture distante (diagnostic)",
  "institution.xapi.lrsUrl": "URL de base du LRS",
  "institution.xapi.optionalKeep": "optionnel pour conserver l’actuel",
  "institution.xapi.password": "Mot de passe / secret",
  "institution.xapi.payloadOptions": "Données incluses dans les statements (parcours)",
  "institution.xapi.profile": "Profil / usage",
  "institution.xapi.save": "Enregistrer",
  "institution.xapi.saveError": "Enregistrement impossible.",
  "institution.xapi.saveSuccess": "Configuration xAPI enregistrée.",
  "institution.xapi.sendCompletion": "Envoyer complétion",
  "institution.xapi.sendDuration": "Envoyer durée",
  "institution.xapi.sendScore": "Envoyer score",
  "institution.xapi.statementsError": "Impossible de charger les statements.",
  "institution.xapi.sync": "Lire un lot (aperçu)",
  "institution.xapi.syncError": "Lecture LRS impossible.",
  "institution.xapi.test": "Tester le LRS",
  "institution.xapi.testError": "Test impossible.",
  "institution.xapi.testFail": "Test LRS échoué.",
  "institution.xapi.testOk": "LRS joignable.",
  "institution.xapi.title": "xAPI — Learning Record Store (LRS)",
  "institution.xapi.username": "Utilisateur (Basic Auth)",
  "loading.label": "Loading…",
  "manager.dashboard.loadError": "Chargement impossible.",
  "manager.dashboard.noReports": "Aucun collaborateur rattaché comme manager dans le SIRH.",
  "manager.dashboard.pendingCount": "en attente",
  "manager.dashboard.pendingWorkflowHint": "Les workflows visibles sont ceux dont vous êtes le demandeur.",
  "manager.dashboard.pendingWorkflowTitle": "Demandes en circuit",
  "manager.dashboard.title": "Tableau de bord Manager",
  "manager.dashboard.workflowBox": "Validation",
  "manager.kpi.activeTrainings": "Formations actives",
  "manager.kpi.completionRate": "Taux de complétion",
  "manager.kpi.pendingWorkflow": "Workflows en attente",
  "manager.nav.requests": "Demandes de formation",
  "manager.nav.reviews": "Évaluations",
  "manager.page.documentTitle": "Manager workspace - LyrraOne",
  "manager.page.subtitle": "Manage training plans and your team progress",
  "manager.page.tabs.dashboard": "Dashboard",
  "manager.page.tabs.requests": "Requests",
  "manager.page.tabs.reviews": "Reviews",
  "manager.page.tabs.team": "Team",
  "manager.page.title": "Manager workspace",
  "manager.requests.commentPlaceholder": "Ajouter un commentaire…",
  "manager.requests.empty": "Aucune demande pour ce filtre.",
  "manager.requests.title": "Demandes de formation",
  "manager.reviews.commentPlaceholder": "Commentaire sur cette compétence…",
  "manager.reviews.lastAssessment": "Dernière éval.",
  "manager.reviews.selectMember": "Sélectionnez un collaborateur pour évaluer",
  "manager.reviews.submitted": "Évaluation soumise",
  "manager.reviews.target": "Cible",
  "manager.reviews.title": "Évaluations de compétences",
  "manager.team.loadError": "Chargement impossible.",
  "notifications.empty": "No notifications yet",
  "notifications.label": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.markRead": "Mark as read",
  "notifications.title": "Notifications",
  "notifications.viewAll": "View all notifications",
  "pages.branding.comingSoonDesc": "Configurez les couleurs, logos et la charte graphique de votre espace de formation.",
  "pages.branding.title": "Identité visuelle",
  "pages.budget.comingSoonDesc": "Planifiez et suivez votre budget de formation, gérez les enveloppes et les dépenses par département.",
  "pages.budget.description": "Gestion du budget de formation",
  "pages.budget.title": "Budget",
  "pages.campaigns.description": "Gestion des campagnes de formation",
  "pages.campaigns.title": "Campagnes",
  "pages.catalog.comingSoonDesc": "Parcourez le catalogue de formations disponibles, recherchez par compétence et inscrivez-vous aux sessions.",
  "pages.catalog.description": "Catalogue des formations",
  "pages.catalog.title": "Catalogue",
  "pages.certificates.comingSoonDesc": "Consultez et téléchargez vos certificats de formation, attestations et badges obtenus.",
  "pages.certificates.description": "Vos certifications et attestations",
  "pages.certificates.title": "Certificats",
  "pages.competencies.comingSoonDesc": "Gérez votre référentiel de compétences, cartographiez les savoir-faire et identifiez les besoins en formation.",
  "pages.competencies.description": "Référentiel de compétences",
  "pages.competencies.title": "Compétences",
  "pages.compliance.comingSoonDesc": "Suivez les formations obligatoires, les certifications et la conformité réglementaire de votre organisation.",
  "pages.compliance.description": "Suivi de la conformité réglementaire",
  "pages.compliance.title": "Conformité",
  "pages.integrations.comingSoonDesc": "Connectez votre plateforme à vos outils RH, SIRH, LMS et autres services pour synchroniser vos données.",
  "pages.integrations.description": "Connexions aux services externes",
  "pages.integrations.title": "Intégrations",
  "pages.learners.statsAdaptiveChoice": "Choix assistes - acceptes: {{accepted}} · refuses: {{declined}}",
  "pages.learners.statsAdaptiveEvaluated": "Adaptations evaluees: {{count}}",
  "pages.learners.statsAdaptiveReplaced": "Versions simplifiees utilisees: {{count}}",
  "pages.reports.comingSoonDesc": "Générez des rapports détaillés sur les activités de formation, les budgets et les indicateurs de performance.",
  "pages.reports.description": "Rapports et bilans de formation",
  "pages.reports.title": "Rapports",
  "pages.requests.description": "Gestion des demandes de formation",
  "pages.requests.title": "Demandes",
  "pages.reviews.comingSoonDesc": "Gérez les entretiens annuels, les évaluations de compétences et le suivi de progression de votre équipe.",
  "pages.reviews.description": "Entretiens et évaluations",
  "pages.reviews.title": "Évaluations",
  "pages.settings.description": "Configuration de votre compte et préférences",
  "pages.settings.title": "Paramètres",
  "pages.skills.description": "Votre profil de compétences",
  "pages.skills.title": "Mes compétences",
  "pages.team.comingSoonDesc": "Visualisez votre équipe, suivez les compétences et les formations de chaque collaborateur.",
  "pages.team.description": "Gestion de votre équipe",
  "pages.team.title": "Mon équipe",
  "pages.training.comingSoonDesc": "Accédez à vos formations en cours, suivez votre progression et reprenez là où vous vous êtes arrêté.",
  "pages.training.description": "Vos parcours de formation en cours",
  "pages.training.title": "Mes formations",
  "pages.webhooks.comingSoonDesc": "Configurez des webhooks pour connecter votre plateforme à des services externes et automatiser vos flux.",
  "pages.webhooks.description": "Configuration des webhooks et intégrations",
  "pages.webhooks.title": "Webhooks",
  "player.manualVoiceoverMic": "Record voice-over for this language",
  "player.manualVoiceoverStudioTitle": "Voice-over recording studio",
  "player.manualVoiceoverStudioLang": "Recording language",
  "player.manualVoiceoverRecord": "Record",
  "player.manualVoiceoverStop": "Stop",
  "player.manualVoiceoverPlay": "Listen",
  "player.manualVoiceoverSave": "Save to block",
  "player.manualVoiceoverClose": "Close",
  "player.manualVoiceoverHint": "On the right: block text or image in the selected language. Record, then save to attach the audio to this language.",
  "player.manualVoiceoverPreviewLoading": "Loading content…",
  "player.manualVoiceoverNoMic": "Microphone or recording is not available in this browser.",
  "player.manualVoiceoverNoText": "No description text long enough for this block.",
  "player.manualVoiceoverSaveError": "Could not save the voice-over to the block.",
  "player.manualVoiceoverUploadError": "Audio upload failed.",
  "player.manualVoiceoverSaved": "Voice-over saved to the block.",
  "player.subflow.blockTitle": "Sous-formation",
  "player.subflow.defaultTitle": "Sous-formation",
  "player.subflow.loadError": "La sous-formation n’a pas pu être chargée.",
  "player.subflow.loading": "Chargement…",
  "player.subflow.missingId": "Aucune sous-formation n’est liée à ce bloc.",
  "player.subflow.noContext": "Impossible de charger la sous-formation (contexte lecteur manquant).",
  "player.subflow.start": "Commencer la sous-formation",
  "qualiopi.actions": "Actions",
  "qualiopi.completion": "Conformité",
  "qualiopi.noDocuments": "Aucun document",
  "qualiopi.notes": "Notes",
  "qualiopi.notesPlaceholder": "Ajouter une note…",
  "quickActions.hint": "Press",
  "quickActions.hintToggle": "to toggle",
  "quickActions.title": "Quick Actions",
  "rh.achievements": "Achievements",
  "rh.addComment": "Add a comment...",
  "rh.addCompetency": "Add Competency",
  "rh.afterApproval": "After Approval",
  "rh.alert.forecast": "Prévision fin d’année",
  "rh.alert.workflow": "Workflows",
  "rh.all": "All",
  "rh.allCompetencies": "All Competencies",
  "rh.allDepartments": "All Departments",
  "rh.allocated": "Alloué",
  "rh.approvalHistory": "Approval History",
  "rh.approve": "Approve",
  "rh.approveConfirm": "Are you sure you want to approve this training request?",
  "rh.approveRequest": "Approve Request",
  "rh.approveSelected": "Approve",
  "rh.approved": "Approved",
  "rh.auditDateUnknown": "Not set",
  "rh.auditOverdue": "Audit overdue",
  "rh.auditScheduleHint": "Set in institution settings",
  "rh.avgGap": "Avg Gap Size",
  "rh.avgLevel": "Avg Level",
  "rh.avgOverall": "Avg Overall",
  "rh.budget.subtitle": "Suivi budgétaire et ROI",
  "rh.budget.title": "Budget formation",
  "rh.budgetAlerts": "Alertes",
  "rh.budgetDashboard": "Budget formation",
  "rh.budgetLoadError": "Impossible de charger le budget.",
  "rh.budgetRemaining": "Budget Remaining",
  "rh.byDepartment": "Budget par direction",
  "rh.competencies": "competencies",
  "rh.competencyMap": "Competency Heatmap",
  "rh.competencyRadar": "Competency Radar",
  "rh.completion": "Completion",
  "rh.compliance": "Compliance",
  "rh.complianceAuditAction.qualiopi_corrective_action_create": "Qualiopi corrective action created",
  "rh.complianceAuditAction.qualiopi_corrective_action_delete": "Qualiopi corrective action deleted",
  "rh.complianceAuditAction.qualiopi_corrective_action_update": "Qualiopi corrective action updated",
  "rh.complianceAuditAction.qualiopi_evidence_create": "Qualiopi evidence added",
  "rh.complianceAuditAction.qualiopi_indicator_update": "Qualiopi indicator updated",
  "rh.complianceAuditAction.compliance_regulatory_watch_create": "Regulatory watch item created",
  "rh.complianceAuditAction.compliance_regulatory_watch_update": "Regulatory watch item updated",
  "rh.complianceAuditAction.compliance_regulatory_watch_delete": "Regulatory watch item deleted",
  "rh.complianceCritical": "Critical: Several criteria are below acceptable thresholds.",
  "rh.complianceGood": "Your organization meets Qualiopi standards. Keep up the good work.",
  "rh.compliancePage.documentTitle": "Compliance & Qualiopi - LyrraOne",
  "rh.compliancePage.subtitle": "Manage regulatory compliance and Qualiopi certification",
  "rh.compliancePage.tabs.dashboard": "Dashboard",
  "rh.compliancePage.tabs.difficulty": "Learning difficulties",
  "rh.compliancePage.tabs.handicap": "Disability liaison",
  "rh.compliancePage.tabs.learnerBilan": "Learner summary",
  "rh.compliancePage.tabs.qualiopi": "Qualiopi",
  "rh.compliancePage.tabs.regulatory": "Regulatory watch",
  "rh.regulatoryWatch.lyrraBadge": "LyrraOne",
  "rh.regulatoryWatch.ofResponse": "Our response / position",
  "rh.regulatoryWatch.ofResponsePlaceholder": "What we did or plan to do…",
  "rh.regulatoryWatch.ackStatus": "Status",
  "rh.regulatoryWatch.ack.pending": "To process",
  "rh.regulatoryWatch.ack.read": "Acknowledged (read)",
  "rh.regulatoryWatch.ack.actionTaken": "Action taken",
  "rh.regulatoryWatch.ack.notApplicable": "Not applicable",
  "rh.regulatoryWatch.pdf.title": "Regulatory watch register",
  "rh.regulatoryWatch.pdf.subtitleFallback": "Institution",
  "rh.regulatoryWatch.pdf.generatedAt": "Generated on {{date}}",
  "rh.regulatoryWatch.pdf.colDate": "Date",
  "rh.regulatoryWatch.pdf.colCategory": "Cat.",
  "rh.regulatoryWatch.pdf.colTitle": "Title",
  "rh.regulatoryWatch.pdf.colDesc": "Description (excerpt)",
  "rh.regulatoryWatch.pdf.colImpact": "Impact",
  "rh.regulatoryWatch.pdf.colOrigin": "Origin",
  "rh.regulatoryWatch.pdf.colStatus": "Status",
  "rh.regulatoryWatch.pdf.colAction": "Action",
  "rh.regulatoryWatch.pdf.colWho": "User",
  "rh.regulatoryWatch.pdf.colWhen": "Timestamp",
  "rh.regulatoryWatch.pdf.originLyrra": "LyrraOne",
  "rh.regulatoryWatch.pdf.originOf": "Training org.",
  "rh.regulatoryWatch.pdf.readYes": "Read",
  "rh.regulatoryWatch.pdf.readNo": "Unread",
  "rh.regulatoryWatch.pdf.actionDone": "Action done",
  "rh.regulatoryWatch.pdf.actionOpen": "Action in progress",
  "rh.regulatoryWatch.pdf.emptyWatch": "No items recorded",
  "rh.regulatoryWatch.pdf.auditSection": "Internal audit log",
  "rh.regulatoryWatch.pdf.auditHint": "Actions recorded automatically by the platform.",
  "rh.regulatoryWatch.pdf.emptyAudit": "No recent events",
  "rh.regulatoryWatch.exportPdf": "Export PDF",
  "rh.regulatoryWatch.exportPdfBusy": "Exporting PDF…",
  "rh.regulatoryWatch.exportPdfError": "PDF export failed",
  "rh.compliancePage.tabs.satisfaction": "Satisfaction",
  "rh.compliancePage.title": "Compliance & Qualiopi",
  "rh.complianceWarning": "Some criteria need attention before the next audit.",
  "rh.compliant": "compliant",
  "rh.confirm": "Confirm Approval",
  "rh.confirmReject": "Confirm Rejection",
  "rh.consumed": "Consommé",
  "rh.costInfo": "Cost Info",
  "rh.critical": "critical",
  "rh.criticalGaps": "Critical (High)",
  "rh.current": "Current",
  "rh.currentLevel": "Current Level",
  "rh.date": "Date",
  "rh.daysRemaining": "days remaining",
  "rh.department": "Department",
  "rh.departmentBreakdown": "Détail par direction",
  "rh.departments": "departments",
  "rh.description": "Description",
  "rh.edit": "Edit",
  "rh.employee": "Employee",
  "rh.employeeInfo": "Employee Info",
  "rh.evolution": "Evolution",
  "rh.evolutionTimeline": "Evolution Timeline",
  "rh.exportReport": "Exporter",
  "rh.gapAnalysis": "Gap Analysis",
  "rh.growth": "Growth this year",
  "rh.lastUpdated": "Last updated",
  "rh.level": "Level",
  "rh.manager": "Manager",
  "rh.needsWork": "needs work",
  "rh.nextAudit": "Next Audit",
  "rh.noAlerts": "Aucune alerte.",
  "rh.noAllocations": "Aucune ligne budgétaire pour cette année.",
  "rh.noDeptData": "Aucune donnée",
  "rh.noGaps": "No gaps found for this filter.",
  "rh.of": "of",
  "rh.ofTotal": "du total",
  "rh.overallCompliance": "Overall Compliance Score",
  "rh.pending": "Pending",
  "rh.provider": "Provider",
  "rh.qualiopiCompliance": "Qualiopi Compliance",
  "rh.qualiopiEmpty": "No Qualiopi data available for this institution.",
  "rh.qualiopiLoading": "Loading Qualiopi reference data…",
  "v2.compliance": "Compliance & Qualiopi",
  "rh.radar": "Radar",
  "rh.reject": "Reject",
  "rh.rejectConfirm": "Are you sure you want to reject this training request?",
  "rh.rejectRequest": "Reject Request",
  "rh.rejectSelected": "Reject",
  "rh.rejected": "Rejected",
  "rh.remaining": "Restant",
  "rh.requestInfo": "Request Info",
  "rh.requests.subtitle": "Workflows de demandes et validations",
  "rh.requests.title": "Demandes de formation",
  "rh.required": "Required",
  "rh.rh": "RH",
  "rh.saveAssessment": "Save Assessment",
  "rh.searchCompetencies": "Search competencies…",
  "rh.selfAssess": "Self",
  "rh.showing": "Showing",
  "rh.skillsSelfAssessment": "Skills & Self-Assessment",
  "rh.spending": "Dépenses",
  "rh.spendingTimeline": "Dépenses par année",
  "rh.status": "Status",
  "rh.targetLevel": "Target Level",
  "rh.totalBudget": "Budget total",
  "rh.totalGaps": "Total Gaps",
  "rh.training": "Training",
  "rh.trainingCost": "Training Cost",
  "rh.trainingRequests": "Training Requests",
  "status.completed": "Terminé",
  "status.inProgress": "En cours",
  "status.notStarted": "Non commencé",
  "store.noResults": "Aucun résultat trouvé",
  "store.subtitle": "Découvrez des formations, templates et ressources créés par la communauté",
  "webinar.room.closeParticipantCamerasView": "Fermer",
  "webinar.room.hideParticipantCameras": "Fermer la vue caméras",
  "webinar.room.participantCamerasViewTitle": "Caméras des participants",
  "webinar.room.showParticipantCameras": "Voir les caméras des participants",
  "designer.validation.formFieldRefsMissing": "« {{title}} »: reference(s) to missing form field(s): {{refs}}.",
  "designer.validation.formFieldRefsOrder": "« {{title}} »: invalid form field variable(s) {{refs}} — the form block must be reached before this block in the flow.",
  "designer.confirmDeleteForm.title": "Delete this form block?",
  "designer.confirmDeleteForm.message": "Other blocks may reference its fields as /fieldId/. Those references will break. You can undo with ⌘Z or Ctrl+Z.",
  "designer.confirmDeleteForm.batchTitle": "Delete selection?",
  "designer.confirmDeleteForm.batchMessage": "The selection includes at least one form block. Slash references elsewhere may break. You can undo with ⌘Z or Ctrl+Z.",
  "episodeEditor.edit.defaultVoiceByLang": "Default voice (podcast language)",
  "episodeEditor.chapters.readByAi": "Read chapter title",
  "episodeEditor.chapters.readByAiHint": "When off, the AI does not read this chapter title aloud. The chapter blocks stay included in the voiceover.",
  "episodeEditor.block.source": "Source",
  "episodeEditor.block.sourceTts": "IA",
  "episodeEditor.block.sourceMic": "Micro",
  "episodeEditor.block.pauseBefore": "Pause avant",
  "episodeEditor.block.pauseBeforeHint": "Silence avant de lire ce bloc (la suite).",
  "episodeEditor.block.pause0": "0 s",
  "episodeEditor.block.pause05": "0,5 s",
  "episodeEditor.block.pause1": "1 s",
  "episodeEditor.block.record": "Enregistrer",
  "episodeEditor.block.stopRecording": "Arrêter",
  "episodeEditor.block.microMode": "Mode micro pour ce bloc",
  "episodeEditor.block.notesRecordingPlaceholder": "Notes optionnelles (non lues automatiquement en micro)",
  "episodeEditor.block.removeRecording": "Supprimer audio",
  "episodeEditor.edit.audioMixedHumanAndAi": "Piste IA + voix micro",
  "episodeEditor.errors.addTextOrRecording": "Ajoutez du texte (synthèse IA) ou enregistrez votre voix sur au moins un bloc avant de générer l'audio.",
  "episodeEditor.errors.saveDraftBeforeRecording": "Impossible de créer l’épisode pour le micro. Ajoutez un titre ou enregistrez depuis un épisode existant.",
  "episodeEditor.errors.microNotSupported": "Micro non disponible dans ce navigateur.",
  "episodeEditor.errors.microPermission": "Impossible d’accéder au micro (permission refusée).",
  "episodeEditor.errors.recordingUploadFailed": "Échec de l’upload de l’enregistrement.",
  "eduflow.designer.toast.flowPastedFromClipboard": "Course created from clipboard",
  "eduflow.designer.loopHandle.loop": "Loop",
  "eduflow.designer.loopHandle.end": "End",
  "trainerTour.driver.progress": "{{current}} of {{total}}",
  "trainerTour.driver.next": "Next",
  "trainerTour.driver.prev": "Previous",
  "trainerTour.driver.done": "Done",
  "trainerTour.driver.gotIt": "Got it",
  "a11y.dialog": "Dialog",
  "a11y.closeDialog": "Close dialog",
  "a11y.dismissNotification": "Dismiss notification",
  "a11y.notificationsRegion": "Notifications",
  "eduflow.blockEditor.audio.estimatedSeconds": "~{{sec}}s estimated",
  "eduflow.blockEditor.audio.fileLabel": "Audio file",
  "eduflow.blockEditor.audio.formatsHint": "MP3, WAV, OGG",
  "eduflow.blockEditor.audio.generateButton": "Generate audio",
  "eduflow.blockEditor.audio.generateTts": "Generate TTS",
  "eduflow.blockEditor.audio.import": "Import",
  "eduflow.blockEditor.audio.langDe": "German",
  "eduflow.blockEditor.audio.langEn": "English",
  "eduflow.blockEditor.audio.langEs": "Spanish",
  "eduflow.blockEditor.audio.langFr": "French",
  "eduflow.blockEditor.audio.langIt": "Italian",
  "eduflow.blockEditor.audio.language": "Language",
  "eduflow.blockEditor.audio.mistralVoice": "Voice (Mistral TTS)",
  "eduflow.blockEditor.audio.mistralVoicePlaceholder": "Mistral voice ID (Mistral console / API)",
  "eduflow.blockEditor.audio.voicesLoading": "Loading voices…",
  "eduflow.blockEditor.audio.voicesLoadError": "Could not load Mistral voices.",
  "eduflow.blockEditor.audio.voicesEmptyHint": "The API returned no voices. Check the Mistral key (Administration → Integrations). Synthesis still uses a default voice.",
  "eduflow.blockEditor.audio.voiceFallbackOption": "{{id}} (default)",
  "eduflow.blockEditor.audio.generating": "Generating…",
  "eduflow.blockEditor.audio.generateNeedText": "Enter text to synthesize first.",
  "eduflow.blockEditor.audio.generateBadResponse": "Invalid TTS response.",
  "eduflow.blockEditor.audio.generateSuccess": "Audio generated.",
  "eduflow.blockEditor.audio.generateError": "Synthesis failed (Mistral TTS / integrations).",
  "eduflow.blockEditor.audio.preview": "Preview",
  "eduflow.blockEditor.audio.source": "Audio source",
  "eduflow.blockEditor.audio.speedLabel": "Speed: {{speed}}x",
  "eduflow.blockEditor.audio.syncWithText": "Sync with text (subtitles)",
  "eduflow.blockEditor.audio.syncWithTextHelp": "In the player: a subtitle-style area under the waveform shows text in segments aligned to playback position (estimated split over audio duration; no VTT file).",
  "eduflow.blockEditor.audio.ttsPlaceholder": "Enter the text to be read by the synthetic voice…",
  "eduflow.blockEditor.audio.ttsText": "Text to synthesize",
  "eduflow.blockEditor.audio.urlLabel": "Or audio file URL",
  "eduflow.blockEditor.audio.urlPlaceholder": "https://example.com/audio.mp3",
  "eduflow.blockEditor.browser.allowExternalAria": "Allow other websites",
  "eduflow.blockEditor.browser.allowExternalHelp": "{{off}}: protected iframe (sandbox) — limits pop-ups and outgoing behavior. {{on}}: better compatibility with rich pages (videos, widgets); navigation possible inside the frame.",
  "eduflow.blockEditor.browser.allowExternalOff": "Off",
  "eduflow.blockEditor.browser.allowExternalOn": "On",
  "eduflow.blockEditor.browser.allowExternalTitle": "Allow other websites",
  "eduflow.blockEditor.browser.frameTitleFallback": "Embedded web page",
  "eduflow.blockEditor.browser.fullscreen": "Fullscreen",
  "eduflow.blockEditor.browser.fullscreenTitle": "Preview — Embedded web page",
  "eduflow.blockEditor.browser.openTab": "Open in a tab",
  "eduflow.blockEditor.browser.preview": "Preview",
  "eduflow.blockEditor.browser.urlHelp": "Enter the full address (https). Preview is framed like a window — this is not a browser: learners cannot change the URL here.",
  "eduflow.blockEditor.browser.urlLabel": "Page URL",
  "eduflow.blockEditor.browser.urlPlaceholder": "https://…",
  "eduflow.blockEditor.chart.addLabel": "Label",
  "eduflow.blockEditor.chart.addSeries": "Series",
  "eduflow.blockEditor.chart.animation": "Animation",
  "eduflow.blockEditor.chart.chartTitle": "Chart title",
  "eduflow.blockEditor.chart.chartType": "Chart type",
  "eduflow.blockEditor.chart.colorTitle": "Color",
  "eduflow.blockEditor.chart.datasets": "Data series ({{count}})",
  "eduflow.blockEditor.chart.defaultLabel": "Label {{n}}",
  "eduflow.blockEditor.chart.defaultSeries": "Series {{n}}",
  "eduflow.blockEditor.chart.interactive": "Interactive (tooltips)",
  "eduflow.blockEditor.chart.labelsX": "Labels (X axis)",
  "eduflow.blockEditor.chart.noSeries": "No series. Click “Series” to add one.",
  "eduflow.blockEditor.chart.readerPreviewHint": "Preview available in player mode",
  "eduflow.blockEditor.chart.seriesNamePlaceholder": "Series name",
  "eduflow.blockEditor.chart.settings": "Settings",
  "eduflow.blockEditor.chart.showGrid": "Show grid",
  "eduflow.blockEditor.chart.showLegend": "Show legend",
  "eduflow.blockEditor.chart.titlePlaceholder": "Optional title",
  "eduflow.blockEditor.chart.typeArea": "Area",
  "eduflow.blockEditor.chart.typeBar": "Bars",
  "eduflow.blockEditor.chart.typeDoughnut": "Doughnut",
  "eduflow.blockEditor.chart.typeLine": "Line",
  "eduflow.blockEditor.chart.typePie": "Pie",
  "eduflow.blockEditor.chart.typeRadar": "Radar",
  "eduflow.blockEditor.timer.sectionTitle": "Timer",
  "eduflow.blockEditor.timer.enable": "Enable timer (player)",
  "eduflow.blockEditor.timer.modeLabel": "Mode",
  "eduflow.blockEditor.timer.modeCountup": "Stopwatch (0 → limit)",
  "eduflow.blockEditor.timer.countupHint": "The last 10 seconds before the limit turn red.",
  "eduflow.blockEditor.timer.modeCountdown": "Countdown (limit → 0)",
  "eduflow.blockEditor.timer.countdownHint": "The last 5 seconds turn red.",
  "eduflow.blockEditor.timer.maxSecondsLabel": "Maximum time (seconds)",
  "eduflow.blockEditor.evaluation.aiQuestions": "Generate questions with AI",
  "eduflow.blockEditor.evaluation.editFullscreen": "Edit form (fullscreen)",
  "eduflow.blockEditor.evaluation.hint": "Open the fullscreen editor to build the form: drag field types from the left column and reorder questions with the handle.",
  "eduflow.blockEditor.evaluation.metaLine": "{{qPart}} · {{pPart}} total",
  "eduflow.blockEditor.evaluation.pointPlural": "points",
  "eduflow.blockEditor.evaluation.pointSingular": "point",
  "eduflow.blockEditor.evaluation.questionPlural": "questions",
  "eduflow.blockEditor.evaluation.questionSingular": "question",
  "eduflow.blockEditor.evaluation.title": "Assessment form",
  "eduflow.blockEditor.evaluationForm.addFreeText": "Add free text",
  "eduflow.blockEditor.evaluationForm.addOption": "Option",
  "eduflow.blockEditor.evaluationForm.close": "Close",
  "eduflow.blockEditor.evaluationForm.delete": "Delete",
  "eduflow.blockEditor.evaluationForm.dropEmptyHint": "Drop a question type from the left panel here, or use the “Add” button.",
  "eduflow.blockEditor.evaluationForm.escapeHint": "Esc to close",
  "eduflow.blockEditor.evaluationForm.expectedValue": "Expected value",
  "eduflow.blockEditor.evaluationForm.footerStats": "{{n}} question(s) · {{pts}} pts total",
  "eduflow.blockEditor.evaluationForm.headerSubtitle": "Drag a question type from the left into the center. Reorder with the ⋮⋮ handle.",
  "eduflow.blockEditor.evaluationForm.headerTitle": "Assessment form editor",
  "eduflow.blockEditor.evaluationForm.maxAttempts": "Max attempts",
  "eduflow.blockEditor.evaluationForm.moveQuestion": "Move question",
  "eduflow.blockEditor.evaluationForm.optionPlaceholder": "Option…",
  "eduflow.blockEditor.evaluationForm.optionsHint": "Click the icon to mark the correct answer(s).",
  "eduflow.blockEditor.evaluationForm.overlayUntitled": "(untitled)",
  "eduflow.blockEditor.evaluationForm.paletteSubtitle": "Drop on the canvas to add a question.",
  "eduflow.blockEditor.evaluationForm.paletteTitle": "Fields",
  "eduflow.blockEditor.evaluationForm.passThreshold": "Pass threshold: {{pct}}%",
  "eduflow.blockEditor.evaluationForm.pointsShort": "pts",
  "eduflow.blockEditor.evaluationForm.qTypeDropdown": "Dropdown",
  "eduflow.blockEditor.evaluationForm.qTypeFile": "File",
  "eduflow.blockEditor.evaluationForm.qTypeMultiple": "Multiple choice",
  "eduflow.blockEditor.evaluationForm.qTypeNumeric": "Numeric",
  "eduflow.blockEditor.evaluationForm.qTypeSingle": "Single choice",
  "eduflow.blockEditor.evaluationForm.qTypeText": "Free text",
  "eduflow.blockEditor.evaluationForm.questionTitlePlaceholder": "Question title…",
  "eduflow.blockEditor.evaluationForm.refAnswerLabel": "Reference answer (optional)",
  "eduflow.blockEditor.evaluationForm.refAnswerPlaceholder": "Expected answer…",
  "eduflow.blockEditor.evaluationForm.refEmptyHint": "Without reference: any non-empty answer is accepted.",
  "eduflow.blockEditor.evaluationForm.required": "Req.",
  "eduflow.blockEditor.evaluationForm.semanticGrading": "AI grading (semantic similarity)",
  "eduflow.blockEditor.evaluationForm.semanticThreshold": "Semantic threshold: {{pct}}%",
  "eduflow.blockEditor.evaluationForm.showCorrect": "Show correct answers",
  "eduflow.blockEditor.evaluationForm.showResults": "Show results",
  "eduflow.blockEditor.evaluationForm.timeLimit": "Time limit",
  "eduflow.blockEditor.evaluationForm.tolerance": "Tolerance ±",
  "eduflow.blockEditor.glossary.add": "Add",
  "eduflow.blockEditor.glossary.categories": "Categories",
  "eduflow.blockEditor.glossary.definitionPlaceholder": "Definition",
  "eduflow.blockEditor.glossary.description": "Description",
  "eduflow.blockEditor.glossary.descriptionPlaceholder": "Help text for vocabulary…",
  "eduflow.blockEditor.glossary.enableQuiz": "Enable built-in quiz",
  "eduflow.blockEditor.glossary.includeInQuiz": "Include in quiz",
  "eduflow.blockEditor.glossary.newCategoryPlaceholder": "New category",
  "eduflow.blockEditor.glossary.noCategory": "No category",
  "eduflow.blockEditor.glossary.panelHint": "Define your terms and enable quiz mode for review.",
  "eduflow.blockEditor.glossary.panelTitle": "Glossary + built-in quiz",
  "eduflow.blockEditor.glossary.termPlaceholder": "Term",
  "eduflow.blockEditor.glossary.termSingular": "Term",
  "eduflow.blockEditor.glossary.termsCount": "Terms ({{count}})",
  "eduflow.blockEditor.glossary.titleLabel": "Glossary title",
  "eduflow.blockEditor.glossary.titlePlaceholder": "Glossary",
  "eduflow.blockEditor.htmlSource.formatButton": "Format",
  "eduflow.blockEditor.htmlSource.formatTitle": "Re-indent and structure HTML (same logic as when entering code mode)",
  "eduflow.blockEditor.htmlSource.findVerb": "find",
  "eduflow.blockEditor.htmlSource.indentVerb": "indents",
  "eduflow.blockEditor.htmlSource.modeLabel": "HTML code mode",
  "eduflow.blockEditor.mindmap.addChild": "Child node",
  "eduflow.blockEditor.mindmap.addMainBranch": "Add a main branch",
  "eduflow.blockEditor.mindmap.branchTitle": "Branch · {{title}}",
  "eduflow.blockEditor.mindmap.centralTheme": "Central theme",
  "eduflow.blockEditor.mindmap.close": "Close",
  "eduflow.blockEditor.mindmap.configureFullscreen": "Configure fullscreen",
  "eduflow.blockEditor.mindmap.descriptionLabel": "Description",
  "eduflow.blockEditor.mindmap.descriptionPlaceholder": "Supporting text",
  "eduflow.blockEditor.mindmap.dialogTitle": "Mind map",
  "eduflow.blockEditor.mindmap.optional": "Optional",
  "eduflow.blockEditor.mindmap.playerHint": "Player: horizontal map (text on colored curve, pills). Zoom in the block header. URL: ↗ opens a new tab.",
  "eduflow.blockEditor.mindmap.remove": "Remove",
  "eduflow.blockEditor.mindmap.structure": "Structure",
  "eduflow.blockEditor.mindmap.subtitleLabel": "Subtitle",
  "eduflow.blockEditor.mindmap.titleLabel": "Title",
  "eduflow.blockEditor.mindmap.titlePlaceholder": "Node title",
  "eduflow.blockEditor.mindmap.untitled": "Untitled",
  "eduflow.blockEditor.mindmap.urlLabel": "URL link",
  "eduflow.blockEditor.mindmap.urlPlaceholder": "https://…",
  "eduflow.blockEditor.pdf.allowDownload": "Allow download",
  "eduflow.blockEditor.pdf.badgePdf": "PDF",
  "eduflow.blockEditor.pdf.completionLabel": "Completion label",
  "eduflow.blockEditor.pdf.completionPlaceholder": "Document viewed",
  "eduflow.blockEditor.pdf.documentFallback": "PDF document",
  "eduflow.blockEditor.pdf.emptyLibrary": "No documents in your library.",
  "eduflow.blockEditor.pdf.focusMode": "Document focus",
  "eduflow.blockEditor.pdf.focusModeDesc": "Minimal chrome, centered reading",
  "eduflow.blockEditor.pdf.importFailed": "Import failed",
  "eduflow.blockEditor.pdf.importFailedGeneric": "Import failed.",
  "eduflow.blockEditor.pdf.importSubtitle": "The document will be added to your document library.",
  "eduflow.blockEditor.pdf.importTitle": "Import a PDF",
  "eduflow.blockEditor.pdf.librarySubtitle": "Upload a PDF to your library or pick an existing one.",
  "eduflow.blockEditor.pdf.libraryTitle": "Document library",
  "eduflow.blockEditor.pdf.loadingDocs": "Loading documents…",
  "eduflow.blockEditor.pdf.myDocuments": "My documents",
  "eduflow.blockEditor.pdf.pagesAuto": "The player will detect the number of pages automatically.",
  "eduflow.blockEditor.pdf.pagesDetected": "{{count}} pages detected",
  "eduflow.blockEditor.pdf.pickFromLibrary": "Select a PDF already in your library.",
  "eduflow.blockEditor.pdf.previewTitle": "Document preview",
  "eduflow.blockEditor.pdf.readerMode": "Modern reader",
  "eduflow.blockEditor.pdf.readerModeDesc": "Page by page, zoom, fullscreen",
  "eduflow.blockEditor.pdf.readingExperience": "Reading experience",
  "eduflow.blockEditor.pdf.showProgress": "Show reading progress",
  "eduflow.blockEditor.pdf.smartExtractSoon": "Smart extraction coming soon",
  "eduflow.blockEditor.pdf.startPage": "Start page",
  "eduflow.blockEditor.pdf.uploadedDesc": "{{name}} is now available in your document library.",
  "eduflow.blockEditor.pdf.uploadedToast": "PDF imported",
  "eduflow.blockEditor.pdf.uploading": "Upload in progress",
  "eduflow.blockEditor.phraseReveal.addPhrase": "Add a phrase",
  "eduflow.blockEditor.phraseReveal.aiSummaryTitle": "Generate an AI recap from upstream blocks",
  "eduflow.blockEditor.phraseReveal.autoScroll": "Auto-scroll",
  "eduflow.blockEditor.phraseReveal.displayDuration": "Duration per phrase (s)",
  "eduflow.blockEditor.phraseReveal.editorHint": "Add one or more phrases with the rich text editor. The player shows one phrase at a time; click or Space for the next.",
  "eduflow.blockEditor.phraseReveal.emptyPhrase": "Empty phrase",
  "eduflow.blockEditor.phraseReveal.importLegacy": "Import the legacy “text to reveal” field as phrases (recommended).",
  "eduflow.blockEditor.phraseReveal.noPhrases": "No phrases yet.",
  "eduflow.blockEditor.phraseReveal.phraseContent": "Phrase content",
  "eduflow.blockEditor.phraseReveal.phrasePlaceholder": "Enter this step's text…",
  "eduflow.blockEditor.phraseReveal.showHistory": "Show phrase history",
  "eduflow.blockEditor.phraseReveal.showHistoryHelp": "Previously seen phrases appear in a card between the current phrase and the block description.",
  "eduflow.blockEditor.presentation.addSlide": "Slide",
  "eduflow.blockEditor.presentation.autoAdvance": "Auto-advance",
  "eduflow.blockEditor.presentation.delayLabel": "Delay: {{sec}}s",
  "eduflow.blockEditor.presentation.duplicateTitleSuffix": " (copy)",
  "eduflow.blockEditor.presentation.globalSettings": "Global settings",
  "eduflow.blockEditor.presentation.layoutImageText": "Image + text",
  "eduflow.blockEditor.presentation.layoutTitleContent": "Title + content",
  "eduflow.blockEditor.presentation.layoutTitleOnly": "Title only",
  "eduflow.blockEditor.presentation.layoutTwoCol": "Two columns",
  "eduflow.blockEditor.presentation.layoutVideoOnly": "Video only",
  "eduflow.blockEditor.presentation.layoutVideoText": "Text + video",
  "eduflow.blockEditor.presentation.loop": "Loop",
  "eduflow.blockEditor.presentation.noSlides": "No slides. Click to add one.",
  "eduflow.blockEditor.presentation.slideCount_one": "{{count}} slide",
  "eduflow.blockEditor.presentation.slideCount_other": "{{count}} slides",
  "eduflow.blockEditor.presentation.slideNumbers": "Slide numbers",
  "eduflow.blockEditor.presentation.slidesHeading": "Slides",
  "eduflow.blockEditor.presentation.transition": "Transition",
  "eduflow.blockEditor.presentation.transitionFade": "Fade",
  "eduflow.blockEditor.presentation.transitionNone": "None",
  "eduflow.blockEditor.presentation.transitionSlide": "Slide",
  "eduflow.blockEditor.presentation.transitionZoom": "Zoom",
  "eduflow.blockEditor.quiz.addAnswer": "Add an answer",
  "eduflow.blockEditor.quiz.addOrderingItem": "Add an item",
  "eduflow.blockEditor.quiz.aiMcqTitle": "Generate an MCQ with AI from upstream blocks",
  "eduflow.blockEditor.quiz.answerPlaceholder": "Answer {{n}}",
  "eduflow.blockEditor.quiz.answersCount": "Answers ({{count}}/10)",
  "eduflow.blockEditor.quiz.branching": "Branching",
  "eduflow.blockEditor.quiz.correctAnswer": "Correct answer",
  "eduflow.blockEditor.quiz.correctAnswerPlaceholder": "Select…",
  "eduflow.blockEditor.quiz.explanation": "Explanation",
  "eduflow.blockEditor.quiz.explanationPlaceholder": "Additional explanation...",
  "eduflow.blockEditor.quiz.false": "False",
  "eduflow.blockEditor.quiz.feedback": "Feedback",
  "eduflow.blockEditor.quiz.ifCorrect": "If correct →",
  "eduflow.blockEditor.quiz.ifIncorrect": "If incorrect →",
  "eduflow.blockEditor.quiz.markAsCorrect": "Mark as correct",
  "eduflow.blockEditor.quiz.markCorrect": "Correct answer",
  "eduflow.blockEditor.quiz.msgCorrect": "Message if correct",
  "eduflow.blockEditor.quiz.msgCorrectPlaceholder": "Well done! That's correct.",
  "eduflow.blockEditor.quiz.msgIncorrect": "Message if incorrect",
  "eduflow.blockEditor.quiz.msgIncorrectPlaceholder": "That's not the right answer.",
  "eduflow.blockEditor.quiz.nextBlockAuto": "Next block (auto)",
  "eduflow.blockEditor.quiz.orderingHint": "Items to order (current order = correct order)",
  "eduflow.blockEditor.quiz.orderingItemPlaceholder": "Item {{n}}",
  "eduflow.blockEditor.quiz.partialScoring": "Partial scoring (MCQ)",
  "eduflow.blockEditor.quiz.question": "Question",
  "eduflow.blockEditor.quiz.questionPlaceholder": "Enter your question...",
  "eduflow.blockEditor.quiz.quizType": "Quiz type",
  "eduflow.blockEditor.quiz.score": "Score",
  "eduflow.blockEditor.quiz.showCorrect": "Show correct answer",
  "eduflow.blockEditor.quiz.shuffle": "Shuffle",
  "eduflow.blockEditor.quiz.true": "True",
  "eduflow.blockEditor.quiz.typeMcq": "MCQ",
  "eduflow.blockEditor.quiz.typeFillBlank": "Fill in the blanks",
  "eduflow.blockEditor.quiz.typeOrdering": "Ordering",
  "eduflow.blockEditor.quiz.typeTrueFalse": "True / False",
  "eduflow.blockEditor.quiz.branchingMode": "Branching mode",
  "eduflow.blockEditor.quiz.branchingNone": "None (linear)",
  "eduflow.blockEditor.quiz.branchingCorrectIncorrect": "Correct / Incorrect",
  "eduflow.blockEditor.quiz.branchingPerAnswer": "Per individual answer",
  "eduflow.blockEditor.loop.maxIterationsLabel": "Maximum number of iterations (0 = infinite)",
  "eduflow.blockEditor.loop.infiniteHint": "The loop will continue indefinitely until the exit condition is met",
  "eduflow.blockEditor.loop.limitedHint": "The loop will stop after at most {{count}} iteration(s)",
  "eduflow.blockEditor.loop.howItWorksTitle": "How it works:",
  "eduflow.blockEditor.loop.howItWorksText": "Connect the \"Loop\" output to the block to repeat until the max iteration count is reached (0 = no cap). Connect \"End\" to where the learner should go when exiting the loop.",
  "eduflow.blockEditor.selfAssessment.addBadge": "Add",
  "eduflow.blockEditor.selfAssessment.addCriterion": "Add",
  "eduflow.blockEditor.selfAssessment.badgeInputPlaceholder": "e.g. Often, Never, Sometimes…",
  "eduflow.blockEditor.selfAssessment.badgeOptionsHint": "Short words or phrases — learners pick them as chips. If none → free text field.",
  "eduflow.blockEditor.selfAssessment.badgeOptionsLabel": "Options (badges)",
  "eduflow.blockEditor.selfAssessment.criteriaSection": "Criteria",
  "eduflow.blockEditor.selfAssessment.criterionDescription": "Description (optional)",
  "eduflow.blockEditor.selfAssessment.criterionDescriptionPh": "Clarify what the learner should notice or how to position themselves…",
  "eduflow.blockEditor.selfAssessment.criterionTitle": "Title",
  "eduflow.blockEditor.selfAssessment.criterionTitlePh": "e.g. Communication, Autonomy…",
  "eduflow.blockEditor.selfAssessment.emptyCriteria": "No criteria yet. Add at least one so learners can self-assess.",
  "eduflow.blockEditor.selfAssessment.moveDown": "Move down",
  "eduflow.blockEditor.selfAssessment.moveUp": "Move up",
  "eduflow.blockEditor.selfAssessment.panelHint": "Define each dimension to rate: a short title and, if needed, a description to guide the learner.",
  "eduflow.blockEditor.selfAssessment.panelTitle": "Self-assessment",
  "eduflow.blockEditor.selfAssessment.removeBadge": "Remove",
  "eduflow.blockEditor.selfAssessment.removeCriterion": "Remove this criterion",
  "eduflow.blockEditor.selfAssessment.responseTypeLabel": "Response type",
  "eduflow.blockEditor.selfAssessment.scaleHint": "From 1 to N (e.g. 5 = Likert)",
  "eduflow.blockEditor.selfAssessment.scaleLabel": "Rating scale",
  "eduflow.blockEditor.selfAssessment.starCountHint": "Often 5",
  "eduflow.blockEditor.selfAssessment.starCountLabel": "Number of stars",
  "eduflow.blockEditor.selfAssessment.textModeHint": "Per criterion: add badge options (selection) or leave empty for a written answer. The global comment stays below criteria in the player.",
  "eduflow.blockEditor.selfAssessment.typeNumeric": "Numbers",
  "eduflow.blockEditor.selfAssessment.typeNumericHint": "Buttons 1 to N",
  "eduflow.blockEditor.selfAssessment.typeStars": "Stars",
  "eduflow.blockEditor.selfAssessment.typeStarsHint": "Visual rating",
  "eduflow.blockEditor.selfAssessment.typeText": "Free text",
  "eduflow.blockEditor.selfAssessment.typeTextHint": "Written answer per criterion",
  "eduflow.blockEditor.shared.alignCenter": "Center",
  "eduflow.blockEditor.shared.alignLeft": "Align left",
  "eduflow.blockEditor.shared.alignRight": "Align right",
  "eduflow.blockEditor.shared.annotationCount_one": "{{count}} annotation",
  "eduflow.blockEditor.shared.annotationCount_other": "{{count}} annotations",
  "eduflow.blockEditor.shared.blocksCount": "{{count}} blocks",
  "eduflow.blockEditor.shared.bold": "Bold",
  "eduflow.blockEditor.shared.border": "Border",
  "eduflow.blockEditor.shared.bulletList": "Bullet list",
  "eduflow.blockEditor.shared.cancel": "Cancel",
  "eduflow.blockEditor.shared.choose": "Choose",
  "eduflow.blockEditor.shared.close": "Close",
  "eduflow.blockEditor.shared.configure": "Configure",
  "eduflow.blockEditor.shared.delete": "Delete",
  "eduflow.blockEditor.shared.duplicate": "Duplicate",
  "eduflow.blockEditor.shared.imageLabel": "Image",
  "eduflow.blockEditor.shared.italic": "Italic",
  "eduflow.blockEditor.shared.layoutPrefix": "Layout: ",
  "eduflow.blockEditor.shared.linked": "Linked",
  "eduflow.blockEditor.shared.maxAttempts": "Max attempts",
  "eduflow.blockEditor.shared.mediaImage": " Image",
  "eduflow.blockEditor.shared.mediaNone": " No media",
  "eduflow.blockEditor.shared.mediaVideo": " Video",
  "eduflow.blockEditor.shared.minutes": "Minutes",
  "eduflow.blockEditor.shared.noImage": "No image",
  "eduflow.blockEditor.shared.numberedList": "Numbered list",
  "eduflow.blockEditor.shared.option": "Option",
  "eduflow.blockEditor.shared.pages": "{{count}} pages",
  "eduflow.blockEditor.shared.points": "Points",
  "eduflow.blockEditor.shared.retry": "Retry",
  "eduflow.blockEditor.shared.rounded": "Rounded corners",
  "eduflow.blockEditor.shared.save": "Save",
  "eduflow.blockEditor.shared.selected": "Selected",
  "eduflow.blockEditor.shared.shadow": "Shadow",
  "eduflow.blockEditor.shared.slideCounter": "Slide {{index}}/{{total}}",
  "eduflow.blockEditor.shared.speedTicks": "{{v}}x",
  "eduflow.blockEditor.shared.strike": "Strikethrough",
  "eduflow.blockEditor.shared.underline": "Underline",
  "eduflow.blockEditor.shared.untitledSlide": "Untitled",
  "eduflow.blockEditor.shared.updatedOn": "Updated {{date}}",
  "eduflow.blockEditor.subflow.emptyPublished": "No published training available",
  "eduflow.blockEditor.subflow.emptySearch": "No training found",
  "eduflow.blockEditor.subflow.linkedTraining": "Linked sub-training",
  "eduflow.blockEditor.subflow.loadError": "Could not load trainings",
  "eduflow.blockEditor.subflow.loading": "Loading…",
  "eduflow.blockEditor.subflow.openInTab": "Open sub-training in a new tab",
  "eduflow.blockEditor.subflow.remove": "Remove",
  "eduflow.blockEditor.subflow.searchPlaceholder": "Search a published training…",
  "eduflow.blockEditor.summary.addItem": "Add a bullet",
  "eduflow.blockEditor.summary.aiRecapTitle": "Generate an AI recap from upstream blocks",
  "eduflow.blockEditor.summary.editorHint": "List concepts or steps seen in the training. Each line appears as a bullet in the player.",
  "eduflow.blockEditor.summary.emptyList": "No bullets yet. Add one.",
  "eduflow.blockEditor.summary.itemPlaceholder": "e.g. Workplace fire risks",
  "eduflow.blockEditor.text.audioTts": "Audio (TTS)",
  "eduflow.blockEditor.text.charWordCount": "{{chars}} characters · {{words}} words",
  "eduflow.blockEditor.text.content": "Content",
  "eduflow.blockEditor.text.contentPlaceholder": "Enter the text block content…",
  "eduflow.blockEditor.text.formatting": "Formatting",
  "eduflow.blockEditor.text.headingH1": "Heading 1",
  "eduflow.blockEditor.text.headingH2": "Heading 2",
  "eduflow.blockEditor.text.headingH3": "Heading 3",
  "eduflow.blockEditor.text.headingH4": "Heading 4",
  "eduflow.blockEditor.text.headingH5": "Heading 5",
  "eduflow.blockEditor.text.headingH6": "Heading 6",
  "eduflow.blockEditor.text.headingLevel": "Heading level",
  "eduflow.blockEditor.text.headingParagraph": "Paragraph",
  "eduflow.blockEditor.text.previewSoon": "Preview (coming soon)",
  "eduflow.blockEditor.text.readTime": "~{{min}} min read",
  "eduflow.blockEditor.text.speedLabel": "Speed: {{speed}}x",
  "eduflow.blockEditor.text.voice": "Voice",
  "eduflow.blockEditor.text.voiceAdam": "Adam (French male)",
  "eduflow.blockEditor.text.voiceBella": "Bella (French female)",
  "eduflow.blockEditor.text.voiceHeart": "Heart (French female)",
  "eduflow.blockEditor.text.voiceMichael": "Michael (English male)",
  "eduflow.blockEditor.text.voiceNova": "Nova (English female)",
  "eduflow.blockEditor.text.voiceSky": "Sky (English female)",
  "eduflow.blockEditor.timeline.addEvent": "Event",
  "eduflow.blockEditor.timeline.alternatingSides": "Alternating sides",
  "eduflow.blockEditor.timeline.animatedReveal": "Animated reveal",
  "eduflow.blockEditor.timeline.colorHint": "Dot color (optional)",
  "eduflow.blockEditor.timeline.colorLabel": "Color",
  "eduflow.blockEditor.timeline.datePlaceholder": "Date or period (e.g. 1789, Jan 2024)",
  "eduflow.blockEditor.timeline.descPlaceholder": "Description (shown when expanded)",
  "eduflow.blockEditor.timeline.emptyEvents": "No events yet. Add one to build the timeline.",
  "eduflow.blockEditor.timeline.events": "Events",
  "eduflow.blockEditor.timeline.horizontal": "Horizontal",
  "eduflow.blockEditor.timeline.iconAward": "Award",
  "eduflow.blockEditor.timeline.iconCheck": "Check",
  "eduflow.blockEditor.timeline.iconClock": "Clock",
  "eduflow.blockEditor.timeline.iconFlag": "Flag",
  "eduflow.blockEditor.timeline.iconStar": "Star",
  "eduflow.blockEditor.timeline.moveDown": "Move down",
  "eduflow.blockEditor.timeline.moveUp": "Move up",
  "eduflow.blockEditor.timeline.orientation": "Orientation",
  "eduflow.blockEditor.timeline.settings": "Settings",
  "eduflow.blockEditor.timeline.showConnectors": "Connector lines",
  "eduflow.blockEditor.timeline.titlePlaceholder": "Event title",
  "eduflow.blockEditor.timeline.untitled": "Untitled",
  "eduflow.blockEditor.timeline.vertical": "Vertical",
  "eduflow.blockEditor.videoSubtitles.cancel": "Cancel",
  "eduflow.blockEditor.videoSubtitles.invalidResponse": "Invalid server response.",
  "eduflow.blockEditor.videoSubtitles.invalidUrl": "Invalid track URL.",
  "eduflow.blockEditor.videoSubtitles.loadError": "Could not load.",
  "eduflow.blockEditor.videoSubtitles.loadFailed": "Could not load track ({{status}}).",
  "eduflow.blockEditor.videoSubtitles.loading": "Loading segments…",
  "eduflow.blockEditor.videoSubtitles.modalSubtitle": "One block per screen appearance. Timing is preserved; only text can be edited.",
  "eduflow.blockEditor.videoSubtitles.modalTitle": "Edit subtitles",
  "eduflow.blockEditor.videoSubtitles.noSegments": "No readable segments in the subtitle file.",
  "eduflow.blockEditor.videoSubtitles.saveFailed": "Could not save.",
  "eduflow.blockEditor.videoSubtitles.saveTrack": "Save track",
  "eduflow.blockEditor.videoSubtitles.savedToast": "Subtitles saved",
  "eduflow.blockEditor.videoSubtitles.segmentN": "Segment {{n}}",
  "eduflow.blockEditor.videoSubtitles.segmentRequiredToast": "At least one segment with text is required.",
  "eduflow.blockEditor.videoSubtitles.trackLang": "Track language: {{label}}",
  "eduflow.blockEditor.video.autoCaptionBullet": "Audio extraction (ffmpeg) then Mistral transcription. Direct .mp4 URL recommended; not a YouTube page.",
  "eduflow.blockEditor.video.autoCaptionErrorFallback": "Check the Mistral key, ffmpeg on the server, and that the video contains audio.",
  "eduflow.blockEditor.video.autoCaptionSection": "Automatic subtitles",
  "eduflow.blockEditor.video.autoCaptionsButton": "Generate subtitles (audio + AI)",
  "eduflow.blockEditor.video.availableSubtitlesChip": "Subtitles available",
  "eduflow.blockEditor.video.completionThreshold": "Completion threshold (%)",
  "eduflow.blockEditor.video.editCueButton": "Edit subtitles (per segment)",
  "eduflow.blockEditor.video.endSeconds": "End (sec)",
  "eduflow.blockEditor.video.escHint": "Esc to close",
  "eduflow.blockEditor.video.libraryEmpty": "No videos available in your library.",
  "eduflow.blockEditor.video.libraryTitle": "Video library",
  "eduflow.blockEditor.video.libraryHint": "Pick a video already uploaded in your designer dashboard.",
  "eduflow.blockEditor.video.libraryLoading": "Loading videos…",
  "eduflow.blockEditor.video.optionalEnd": "Optional",
  "eduflow.blockEditor.video.accent.primary": "Primary",
  "eduflow.blockEditor.video.aspectFormat": "Aspect ratio",
  "eduflow.blockEditor.video.aspect.ratio169": "16:9",
  "eduflow.blockEditor.video.aspect.ratio219": "21:9",
  "eduflow.blockEditor.video.aspect.ratio43": "4:3",
  "eduflow.blockEditor.video.aspect.ratio11": "1:1",
  "eduflow.blockEditor.video.pickFromLibrary": "Select",
  "eduflow.blockEditor.video.playerBadge": "Video player",
  "eduflow.blockEditor.video.previewTitleFallback": "Video player",
  "eduflow.blockEditor.video.reduced": "Minimize",
  "eduflow.blockEditor.video.regenerateCaptions": "Regenerate",
  "eduflow.blockEditor.video.previewHint": "Upload, YouTube, or direct URL with customisable styling.",
  "eduflow.blockEditor.video.previewIframeTitle": "Video preview",
  "eduflow.blockEditor.video.subtitleBadge": "Subtitles",
  "eduflow.blockEditor.video.selected": "Selected",
  "eduflow.blockEditor.video.designTab": "Design",
  "eduflow.blockEditor.video.radius.soft": "Soft",
  "eduflow.blockEditor.video.radius.rounded": "Rounded",
  "eduflow.blockEditor.video.radius.square": "Square",
  "eduflow.blockEditor.video.shadow.soft": "Soft",
  "eduflow.blockEditor.video.shadow.glow": "Glow",
  "eduflow.blockEditor.video.shadow.dramatic": "Dramatic",
  "eduflow.blockEditor.video.shadowLabel": "Shadow",
  "eduflow.blockEditor.video.radiusCornerLabel": "Corners",
  "eduflow.blockEditor.video.themeEditorial.desc": "Light, clean, institutional",
  "eduflow.blockEditor.video.themeEditorial.label": "Editorial",
  "eduflow.blockEditor.video.themeCinema.desc": "Dark, premium, immersive",
  "eduflow.blockEditor.video.themeCinema.label": "Cinema",
  "eduflow.blockEditor.video.themeGlass.desc": "Translucent, modern, bright",
  "eduflow.blockEditor.video.themeGlass.label": "Glass",
  "eduflow.blockEditor.video.themeApp.desc": "Default, aligned with the current theme",
  "eduflow.blockEditor.video.themeApp.label": "Application",
  "eduflow.blockEditor.video.themeAccent": "Accent color",
  "eduflow.blockEditor.video.themePlayer": "Player theme",
  "eduflow.blockEditor.video.toast.autoCaptionsError": "Automatic subtitles unavailable",
  "eduflow.blockEditor.video.toast.autoCaptionsOk": "Subtitles generated",
  "eduflow.blockEditor.video.toast.autoCaptionsOkDesc": "They appear in real time during playback in the player.",
  "eduflow.blockEditor.video.toast.uploadErrorDesc": "Import failed.",
  "eduflow.blockEditor.video.toast.uploadErrorTitle": "Could not import",
  "eduflow.blockEditor.video.toast.uploadedDesc": "{{name}} is ready in your video block.",
  "eduflow.blockEditor.video.toast.uploadedTitle": "Video imported",
  "eduflow.blockEditor.video.fullscreenExpandTitle": "Open fullscreen",
  "eduflow.blockEditor.video.fullscreenHeading": "Video block",
  "eduflow.blockEditor.video.importDragTitle": "Import a video",
  "eduflow.blockEditor.video.importFormats": "MP4, WebM, OGG, MOV · max {{maxMb}} MB in the UI",
  "eduflow.blockEditor.video.noneSelected": "No video selected",
  "eduflow.blockEditor.video.playbackTab": "Playback",
  "eduflow.blockEditor.video.playbackSettingsTitle": "Playback settings",
  "eduflow.blockEditor.video.loop": "Loop",
  "eduflow.blockEditor.video.autoplay": "Autoplay",
  "eduflow.blockEditor.video.mutedStart": "Muted on start",
  "eduflow.blockEditor.video.showControls": "Show controls",
  "eduflow.blockEditor.video.embedSubtitlesYoutubeVimeo": "On {{platform}}, enable subtitles in the embedded player (CC). The player loads tracks provided by the platform.",
  "eduflow.blockEditor.video.trackReadyHint": "WebVTT track ready: in the player, subtitles follow the learner’s chosen language (all 12 player languages; translated on the fly if needed).",
  "eduflow.blockEditor.video.langTranscriptionTrack": "Language (transcription / source track)",
  "eduflow.blockEditor.video.placeholderUrlGeneric": "https://example.com/video.mp4",
  "eduflow.blockEditor.video.placeholderVimeo": "https://vimeo.com/…",
  "eduflow.blockEditor.video.placeholderYoutube": "https://www.youtube.com/watch?v=…",
  "eduflow.blockEditor.video.invalidUrlSource": "Invalid URL for this source",
  "eduflow.blockEditor.video.urlHelpDirect": "Works with direct URLs to a video file.",
  "eduflow.blockEditor.video.labelUrlGeneric": "Video URL",
  "eduflow.blockEditor.video.labelUrlVimeo": "Vimeo URL",
  "eduflow.blockEditor.video.labelUrlYoutube": "YouTube URL",
  "eduflow.blockEditor.video.readyInBlock": "Video ready in block",
  "eduflow.blockEditor.video.uploadInProgress": "Upload in progress",
  "eduflow.blockEditor.video.sectionSubtitlesDesign": "Subtitles",
  "eduflow.blockEditor.video.sourceLabel": "Video source",
  "eduflow.blockEditor.video.sourceTab": "Source",
  "eduflow.blockEditor.video.sourceUrl": "URL",
  "eduflow.blockEditor.video.sourceUpload": "File",
  "eduflow.blockEditor.video.startSeconds": "Start (sec)",
  "eduflow.blockEditor.video.showPlayerHeader": "Show player header",
  "eduflow.blockEditor.video.accent.amber": "Amber",
  "eduflow.blockEditor.video.accent.emerald": "Emerald",
  "eduflow.blockEditor.richText.collapsedHintHtml": "Minimize editor (HTML mode on)",
  "eduflow.blockEditor.richText.collapsedHintReopen": "Click to reopen the editor",
  "eduflow.blockEditor.richText.defaultPlaceholder": "Write your content here…",
  "eduflow.blockEditor.richText.slashPlaceholder": "Start typing or type '/' for commands",
  "eduflow.blockEditor.richText.slashButtonDefaultLabel": "Button",
  "eduflow.blockEditor.richText.slash.empty": "No matching command",
  "eduflow.blockEditor.richText.slash.menuLabel": "Formatting commands",
  "eduflow.blockEditor.richText.slash.sectionBasic": "Basic",
  "eduflow.blockEditor.richText.slash.sectionFormFields": "Form fields",
  "eduflow.blockEditor.richText.slash.helpMeWrite": "Help me write",
  "eduflow.blockEditor.richText.slash.helpMeWriteKeywords": "ai assistant writing",
  "eduflow.blockEditor.richText.slash.paragraph": "Paragraph",
  "eduflow.blockEditor.richText.slash.paragraphKeywords": "normal text",
  "eduflow.blockEditor.richText.slash.heading2": "Heading 2",
  "eduflow.blockEditor.richText.slash.heading2Keywords": "h2 subtitle",
  "eduflow.blockEditor.richText.slash.heading3": "Heading 3",
  "eduflow.blockEditor.richText.slash.heading3Keywords": "h3",
  "eduflow.blockEditor.richText.slash.orderedList": "Numbered list",
  "eduflow.blockEditor.richText.slash.orderedListKeywords": "numbers 1 2 3",
  "eduflow.blockEditor.richText.slash.bulletList": "Bulleted list",
  "eduflow.blockEditor.richText.slash.bulletListKeywords": "bullets points",
  "eduflow.blockEditor.richText.slash.blockquote": "Blockquote",
  "eduflow.blockEditor.richText.slash.blockquoteKeywords": "quote",
  "eduflow.blockEditor.richText.slash.divider": "Divider",
  "eduflow.blockEditor.richText.slash.dividerKeywords": "line hr rule",
  "eduflow.blockEditor.richText.slash.code": "Code",
  "eduflow.blockEditor.richText.slash.codeKeywords": "block snippet",
  "eduflow.blockEditor.richText.slash.emoji": "Emoji",
  "eduflow.blockEditor.richText.slash.emojiKeywords": "smiley emoticon",
  "eduflow.blockEditor.richText.slash.button": "Button",
  "eduflow.blockEditor.richText.slash.buttonKeywords": "link cta action",
  "eduflow.blockEditor.richText.fullscreenTitleFallback": "Editor",
  "eduflow.blockEditor.richText.calloutBody": "Your text here…",
  "eduflow.blockEditor.richText.calloutTitle": "Highlight title",
  "eduflow.blockEditor.richText.fullscreen": "Fullscreen",
  "eduflow.blockEditor.richText.highlight": "Highlight",
  "eduflow.blockEditor.richText.imageTab": "Image",
  "eduflow.blockEditor.richText.importTab": "Import",
  "eduflow.blockEditor.richText.infoPanelBody": "Add key information for learners.",
  "eduflow.blockEditor.richText.infoPanelTitle": "Good to know",
  "eduflow.blockEditor.richText.inlineCode": "Inline code",
  "eduflow.blockEditor.richText.insertBadge": "Badge",
  "eduflow.blockEditor.richText.insertCallout": "Callout",
  "eduflow.blockEditor.richText.insertCalloutCompact": "Insert callout",
  "eduflow.blockEditor.richText.insertImage": "Insert image",
  "eduflow.blockEditor.richText.insertImageAction": "Insert image",
  "eduflow.blockEditor.richText.insertInfoPanel": "Info panel",
  "eduflow.blockEditor.richText.insertVideo": "Insert video",
  "eduflow.blockEditor.richText.insertVideoAction": "Insert video",
  "eduflow.blockEditor.richText.libraryTab": "My images",
  "eduflow.blockEditor.richText.link": "Link",
  "eduflow.blockEditor.richText.linkOk": "OK",
  "eduflow.blockEditor.richText.linkPlaceholderHttps": "https://…",
  "eduflow.blockEditor.richText.linkPrompt": "Link URL:",
  "eduflow.blockEditor.richText.mediaFormatsHint": "PNG, JPG, GIF, WebP · max 10 MB",
  "eduflow.blockEditor.richText.minimizeToolbar": "Minimize",
  "eduflow.blockEditor.richText.modalLibraryEmpty": "No images in your library",
  "eduflow.blockEditor.richText.modalUploading": "Uploading…",
  "eduflow.blockEditor.richText.openImportTab": "Import an image",
  "eduflow.blockEditor.richText.placeholderImageUrl": "https://example.com/image.jpg",
  "eduflow.blockEditor.richText.placeholderYoutube": "https://youtube.com/watch?v=…",
  "eduflow.blockEditor.richText.quote": "Quote",
  "eduflow.blockEditor.richText.redo": "Redo",
  "eduflow.blockEditor.richText.separatorRule": "Divider",
  "eduflow.blockEditor.richText.showHtmlSource": "Show / edit HTML",
  "eduflow.blockEditor.richText.returnToVisual": "Return to visual editor",
  "eduflow.blockEditor.richText.tplBadgeLabel": "Badge",
  "eduflow.blockEditor.richText.uploadDropPrompt": "Drag and drop or",
  "eduflow.blockEditor.richText.uploadDropClick": "click to select",
  "eduflow.blockEditor.richText.heading1": "Heading 1",
  "eduflow.blockEditor.richText.heading2": "Heading 2",
  "eduflow.blockEditor.richText.heading3": "Heading 3",
  "eduflow.blockEditor.richText.justify": "Justify",
  "eduflow.blockEditor.richText.undo": "Undo",
  "eduflow.blockEditor.richText.videoYoutubePaste": "Paste the YouTube URL below",
  "eduflow.blockEditor.richText.videoYoutubeToolbar": "YouTube video",
  "eduflow.blockEditor.richText.urlTab": "URL"
};
